import React, { useState, useEffect } from 'react';
import Logo from "../assets/digiworks-logo.png";
import Logo2 from "../assets/digiworks-logo-v2.png";
import Cube from "../assets/cubes.png";
import AgenticAiVisual from "../assets/agentic-ai-visual.webp";

function Main() {
  const [isDark, setIsDark] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [serviceExpandIndex, setServiceExpandIndex] = useState("00");
  const [profileExpandIndex, setProfileExpandIndex] = useState("00");
  const [stage, setStage ] = useState("discover");

  useEffect(() => {
    if (localStorage.getItem('theme') === 'dark' || !('theme' in localStorage) || window.matchMedia('(prefers-color-scheme: dark)').matches) {
      setIsDark(true);
      document.documentElement.classList.add('dark');
    } else {
      setIsDark(false);
      document.documentElement.classList.remove('dark');
    }
  }, []);

  const toggleTheme = () => {
    if (isDark) {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
      setIsDark(false);
    } else {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
      setIsDark(true);
    }
  };

  const handleScroll = (e, targetId) => {
    e.preventDefault();
    const targetSection = document.getElementById(targetId);
    if (targetSection) {
      targetSection.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const toogleServiceExpand = (index) => {
    if (serviceExpandIndex === index) {
      setServiceExpandIndex("00");
    }
    else {
      setServiceExpandIndex(index);
    }
  }

  return (
    <main>
       <header className="bg-surface-4 text-on-surface-1 z-20" style={{ position: 'sticky', top:0 }}>
        <div className="mx-auto flex max-w-[95rem] items-center justify-between px-8 py-6">
          <div className="text-2xl font-bold tracking-wide text-on-surface-1">
            <a href='intro' onClick={(e) => handleScroll(e, 'intro')}>
              <img src={Logo} alt='logo' className="w-[130px] dark:hidden"/>
              <img src={Logo2} alt='logo' className="w-[130px] hidden dark:block"/>
            </a>
          </div>
          <nav className="hidden items-center gap-10 text-sm font-medium text-on-surface-1 lg:flex">
            <a href="#about" onClick={(e) => handleScroll(e, 'about')} className="transition hover:text-primary">About</a>
            <a href="#services" onClick={(e) => handleScroll(e, 'services')} className="transition hover:text-primary">Services</a>
            <a href="#products" onClick={(e) => handleScroll(e, 'products')} className="transition hover:text-primary">Products</a>
            <a href="#competency" onClick={(e) => handleScroll(e, 'competency')} className="transition hover:text-primary">Agentic AI</a>
            <a href="#methodology" onClick={(e) => handleScroll(e, 'methodology')} className="transition hover:text-primary">Methodology</a>
            <a href="#leadership" onClick={(e) => handleScroll(e, 'leadership')} className="transition hover:text-primary">Leadership</a>
            <a href="#contact" onClick={(e) => handleScroll(e, 'contact')} className="transition hover:text-primary">Contact</a>
          </nav>
          <button 
            onClick={toggleTheme} 
            className="ml-4 p-2 rounded-lg bg-btn-bg text-btn-text hover:opacity-80 transition-all flex items-center gap-2"
          >
            {isDark ? '☀️ Light' : '🌙 Dark'}
          </button>
          <button onClick={(e) => handleScroll(e, 'contact')} 
            className="hidden lg:block rounded-md bg-primary px-6 py-3 text-sm font-semibold text-on-primary shadow-[0_0_20px_rgba(232,117,26,0.35)] transition hover:opacity-90">
            Get in Touch
          </button>
          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} 
            className="block lg:hidden text-on-surface-1 focus:outline-none p-2"
            aria-label="Toggle Menu"
          >
            {isMobileMenuOpen ? (
              <svg className="w-6 height-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"/></svg>
            ) : (
              <svg className="w-6 height-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"/></svg>
            )}
          </button>
        </div>
        <nav className={`flex flex-col lg:hidden gap-4 px-8 text-sm font-medium text-on-surface-2 transition-all duration-1000 ease-in-out overflow-hidden ${isMobileMenuOpen ? 'max-h-[500px] opacity-100  py-6' : 'max-h-0 opacity-0'}`}>
          <a href="#about" onClick={(e) => handleScroll(e, 'about')} className="transition hover:text-primary">About</a>
          <a href="#services" onClick={(e) => handleScroll(e, 'services')} className="transition hover:text-primary">Services</a>
          <a href="#products" onClick={(e) => handleScroll(e, 'products')} className="transition hover:text-primary">Products</a>
          <a href="#competency" onClick={(e) => handleScroll(e, 'competency')} className="transition hover:text-primary">Agentic AI</a>
          <a href="#methodology" onClick={(e) => handleScroll(e, 'methodology')} className="transition hover:text-primary">Methodology</a>
          <a href="#leadership" onClick={(e) => handleScroll(e, 'leadership')} className="transition hover:text-primary">Leadership</a>
          <a href="#contact" onClick={(e) => handleScroll(e, 'contact')} className="transition hover:text-primary">Contact</a>
          <button onClick={(e) => handleScroll(e, 'contact')} 
            className="w-full mt-2 text-center rounded-md bg-primary px-6 py-3 text-sm font-semibold text-on-primary shadow-[0_0_20px_rgba(232,117,26,0.35)] transition hover:opacity-90">
            Get in Touch
          </button>
        </nav>
      </header>

      <section className="pb-16 relative min-h-screen overflow-hidden bg-surface-1 text-on-surface-1" id="intro">
        <div className="absolute inset-0">
          <div className="absolute right-0 top-0 h-full w-1/2 bg-[radial-gradient(circle_at_center,rgba(26,66,104,0.45),transparent_70%)] dark:bg-[radial-gradient(circle_at_center,rgba(26,34,53,0.75),transparent_70%)]"></div>
          <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,1)_35%,rgba(255,255,255,0.75)_60%,rgba(255,255,255,0.9)_100%)] dark:bg-[linear-gradient(to_right,rgba(10,15,30,1)_35%,rgba(10,15,30,0.65)_60%,rgba(10,15,30,0.95)_100%)]"></div>
        </div>
        <div className="absolute right-0 top-0 h-full w-1/2 opacity-20 dark:opacity-30">
          <div className="h-full w-full invert dark:invert-0" style={{ backgroundImage: `url(${Cube})` }}></div>
        </div>
        <div className="relative z-10 mx-auto flex max-w-[95rem] items-center px-8 py-24 lg:min-h-[85vh]">
          <div className="max-w-[50rem]">
            <div className="mb-8 flex items-center gap-3">
              <div className="h-[2px] w-8 bg-primary"></div>
              <p className="text-xs font-mono font-semibold uppercase tracking-[0.35em] text-primary">
                AI-Centric Enterprise Technology • Bangladesh To Global
              </p>
            </div>
            <h1 className="max-w-4xl dark:text-on-primary text-5xl font-space font-extrabold leading-[1.05] tracking-tight md:text-7xl">
              AI-First
              <span className="text-primary"> Enterprise</span>
              <br />
              Transformation
              <br />
              <span className="text-primary">Partner</span>
            </h1>
            <h2 className="mt-8 text-2xl font-space font-bold text-primary">
              Empowering Your Digital Horizon
            </h2>
            <p className="mt-6 max-w-2xl text-lg leading-relaxed text-on-surface-2/80">
              DIGIWORKS LIMITED is an AI-centric technology company from Bangladesh,
              focused on building intelligent digital solutions for enterprises,
              institutions, growth-stage technology providers, and international
              clients.
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
              <button
                onClick={(e) => handleScroll(e, 'services')} 
                className="flex items-center gap-2 rounded-md bg-primary px-8 py-4 text-sm font-space font-semibold text-on-primary shadow-[0_0_25px_rgba(232,117,26,0.35)] transition hover:opacity-90">
                Explore Our Services
                <span>→</span>
              </button>
              <button 
                onClick={(e) => handleScroll(e, 'contact')}
                className="rounded-md border border-on-surface-2/20 bg-surface-2/30 px-8 py-4 text-sm font-space font-semibold text-on-surface-1 backdrop-blur-sm transition hover:border-primary hover:text-primary">
                Start a Conversation
              </button>
            </div>
            <div className="mt-10 grid grid-cols-2 gap-10 md:grid-cols-4">
              <div>
                <h3 className="text-4xl font-space font-extrabold dark:text-on-primary">25+</h3>
                <p className="mt-2 text-[10px] font-mono uppercase tracking-[0.25em] text-on-surface-2/50">
                  Years Combined Leadership
                </p>
              </div>
              <div>
                <h3 className="text-4xl font-space font-extrabold dark:text-on-primary">6</h3>
                <p className="mt-2 text-[10px] font-mono uppercase tracking-[0.25em] text-on-surface-2/50">
                  Strategic Service Lines
                </p>
              </div>
              <div>
                <h3 className="text-4xl font-space font-extrabold dark:text-on-primary">AI-First</h3>
                <p className="mt-2 text-[10px] font-mono uppercase tracking-[0.25em] text-on-surface-2/50">
                  Engineering Philosophy
                </p>
              </div>
              <div>
                <h3 className="text-4xl font-space font-extrabold lg:whitespace-nowrap dark:text-on-primary">BD → Global</h3>
                <p className="mt-2 text-[10px] font-mono uppercase tracking-[0.25em] text-on-surface-2/50">
                  Market Ambition
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="pt-16 relative overflow-hidden bg-surface-1 py-24 text-on-surface-1 dark:bg-surface-1 dark:text-on-surface-1" id="about">
        <div className="absolute inset-0">
          <div className="absolute right-0 top-0 h-full w-1/2 bg-[radial-gradient(circle_at_center,rgba(26,66,104,0.22),transparent_70%)] dark:bg-[radial-gradient(circle_at_center,rgba(26,34,53,0.45),transparent_70%)]"></div>
        </div>
        <div className="relative z-10 mx-auto grid max-w-[95rem] grid-cols-1 gap-16 px-8 lg:grid-cols-2 lg:items-center">
          <div>
            <div className="mb-8 flex items-center gap-3">
              <p className="text-xs font-semibold uppercase tracking-[0.35em] text-primary font-mono">
                [01] — Corporate Overview
              </p>
            </div>
            <h2 className="max-w-2xl text-4xl lg:text-5xl dark:text-on-primary font-space font-extrabold leading-tight tracking-tight">
              An AI-First Enterprise
              <br />
              <span className="text-primary">
                Transformation Partner
              </span>
            </h2>
            <div className="mt-12 space-y-8 text-lg leading-relaxed text-on-surface-2/75">
              <p>
                DIGIWORKS LIMITED is an AI-centric technology company from Bangladesh
                focused on building intelligent digital solutions for enterprises,
                institutions, growth-stage technology providers, and international
                clients. The company combines software engineering, artificial
                intelligence, enterprise infrastructure expertise, and strategic
                consulting to help organizations modernize operations, automate
                workflows, improve decision-making, and develop scalable digital
                products.
              </p>
              <p>
                DIGIWORKS is positioned not merely as a software development vendor,
                but as an 
                <span className="font-bold text-on-surface-1 dark:text-on-primary">
                  &nbsp; AI-first enterprise transformation partner.&nbsp;
                </span>
                Its core strength lies in identifying real business problems and
                converting them into practical, secure, scalable, and commercially
                meaningful technology solutions.
              </p>
            </div>
            <div className="mt-10 rounded-2xl border border-surface-3 bg-surface-2 p-8 backdrop-blur-sm">
              <div className="mb-5 flex items-center gap-3">
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" 
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="text-primary">
                      <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path>
                      <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                </div>
                <h3 className="text-xs font-bold font-mono uppercase tracking-[0.3em] text-primary">
                  Vision
                </h3>
              </div>
              <p className="font-semibold font-space leading-relaxed text-on-surface-1">
                To become a leading AI-centric technology company from Bangladesh,
                empowering enterprises locally and globally through intelligent
                software, scalable SaaS platforms, trusted digital infrastructure,
                and world-class AI talent.
              </p>
            </div>
            <div className="mt-6 rounded-2xl border border-surface-3 bg-surface-2 p-8 backdrop-blur-sm">
              <div className="mb-5 flex items-center gap-3">
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
                    stroke-linecap="round" stroke-linejoin="round" className="text-primary">
                      <circle cx="12" cy="12" r="10"></circle>
                      <circle cx="12" cy="12" r="6"></circle>
                      <circle cx="12" cy="12" r="2"></circle>
                  </svg>
                </div>
                <h3 className="text-xs font-bold font-mono uppercase tracking-[0.3em] text-primary">
                  Mission
                </h3>
              </div>
              <p className="leading-relaxed text-on-surface-2/75">
                We identify real business problems and transform them into intelligent
                digital solutions through AI-powered software, SaaS innovation,
                enterprise AI advisory, secure infrastructure implementation, and the
                development of skilled AI engineers and consultants who deliver
                measurable impact for clients in Bangladesh and across global markets.
              </p>
            </div>
          </div>
          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              <div className="flex items-center justify-center bg-[radial-gradient(circle_at_center,rgba(26,66,104,0.45),transparent_70%)] dark:bg-[radial-gradient(circle_at_center,rgba(26,34,53,0.75),transparent_70%)]">
                <div className="flex flex-col items-center gap-6 text-primary">
                  <div className="space-y-2 text-center">
                    <img src='https://d2xsxph8kpxj0f.cloudfront.net/310519663482603392/LppHwRBjKmxosMqbEB5ojG/about-visual-bJvK5yVpiP4DNkFj6fgYQu.webp' />
                  </div>
                </div>
              </div>
              <div className="absolute bottom-4 left-4 right-4 rounded border border-surface-3 bg-surface-1 p-5 dark:bg-surface-2/70">
                <div className="flex items-start gap-3">
                  <div className="mt-1 text-primary">
                    ⚡
                  </div>
                  <p className="text-xs font-mono leading-relaxed text-on-surface-2/75">
                    <span className="font-bold text-on-surface-1">
                      Positioning:
                    </span>
                    DIGIWORKS LIMITED helps organizations transform ideas, business
                    challenges, and operational inefficiencies into secure, scalable,
                    AI-powered software systems and market-ready SaaS products.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="bg-surface-1 pt-8 pb-8">
        <div style={{ background: 'linear-gradient(90deg, #0000, #e8751a4d, #0000)', height: '1px'}}></div>
      </div>

      <section className="relative overflow-hidden bg-surface-1 py-24 text-on-surface-1">
        <div className="relative z-10 mx-auto max-w-[95rem] px-8">
          <div className="mb-14 flex items-center gap-3">
            <p className="text-xs font-mono font-semibold uppercase tracking-[0.35em] text-primary">
              Mission Pillars
            </p>
          </div>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-5">
            <div className="group rounded border border-surface-3 bg-surface-2 p-8 backdrop-blur-sm transition duration-300 hover:-translate-y-1 hover:border-[#774c2a] hover:shadow-[0_0_30px_rgba(232,117,26,0.08)]">
              <div className="mb-5 text-sm font-mono font-bold tracking-[0.25em] text-primary">
                01
              </div>
              <h3 className="font-space font-bold leading-snug dark:text-on-primary">
                Build Intelligent Software
              </h3>
              <p className="mt-4 text-xs leading-relaxed text-on-surface-2">
                We design and develop AI-powered applications that solve real
                operational, commercial, and customer experience problems.
              </p>
            </div>
            <div className="group rounded border border-surface-3 bg-surface-2 p-8 backdrop-blur-sm transition duration-300 hover:-translate-y-1 hover:border-[#774c2a] hover:shadow-[0_0_30px_rgba(232,117,26,0.08)]">
              <div className="mb-5 text-sm font-mono font-bold tracking-[0.25em] text-primary">
                02
              </div>
              <h3 className="font-space font-bold leading-snug dark:text-on-primary">
                Create Scalable SaaS Products
              </h3>
              <p className="mt-4 text-xs leading-relaxed text-on-surface-2">
                We identify market needs and transform repeatable business problems
                into SaaS platforms for Bangladesh and global markets.
              </p>
            </div>
            <div className="group rounded border border-surface-3 bg-surface-2 p-8 backdrop-blur-sm transition duration-300 hover:-translate-y-1 hover:border-[#774c2a] hover:shadow-[0_0_30px_rgba(232,117,26,0.08)]">
              <div className="mb-5 text-sm font-mono font-bold tracking-[0.25em] text-primary">
                03
              </div>
              <h3 className="font-space font-bold leading-snug dark:text-on-primary">
                Guide Enterprise AI Adoption
              </h3>
              <p className="mt-4 text-xs leading-relaxed text-on-surface-2">
                We help organizations define digital transformation roadmaps, adopt
                AI responsibly, and create measurable business value.
              </p>
            </div>
            <div className="group rounded border border-surface-3 bg-surface-2 p-8 backdrop-blur-sm transition duration-300 hover:-translate-y-1 hover:border-[#774c2a] hover:shadow-[0_0_30px_rgba(232,117,26,0.08)]">
              <div className="mb-5 text-sm font-mono font-bold tracking-[0.25em] text-primary">
                04
              </div>
              <h3 className="font-space font-bold leading-snug dark:text-on-primary">
                Implement Reliable Infrastructure
              </h3>
              <p className="mt-4 text-xs leading-relaxed text-on-surface-2">
                We design and deploy secure, scalable, and future-ready infrastructure
                that supports enterprise applications and AI workloads.
              </p>
            </div>
            <div className="group rounded border border-surface-3 bg-surface-2 p-8 backdrop-blur-sm transition duration-300 hover:-translate-y-1 hover:border-[#774c2a] hover:shadow-[0_0_30px_rgba(232,117,26,0.08)]">
              <div className="mb-5 text-sm font-mono font-bold tracking-[0.25em] text-primary">
                05
              </div>
              <h3 className="font-space font-bold leading-snug dark:text-on-primary">
                Develop AI Engineers & Consultants
              </h3>
              <p className="mt-4 text-xs leading-relaxed text-on-surface-2">
                We build strong technical and consulting capabilities so enterprises
                can access skilled AI professionals for transformation initiatives.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden bg-surface-1 py-24 text-on-surface-1 bg-surface-4" id="services">
        <div className="relative z-10 mx-auto max-w-[95rem] px-8">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:items-start">
            <div>
              <div className="mb-8 flex items-center gap-3">
                <p className="text-xs font-semibold uppercase tracking-[0.35em] text-primary">
                  [02] — Service Portfolio
                </p>
              </div>
              <h2 className="max-w-4xl text-4xl lg:text-5xl font-space font-extrabold leading-tight tracking-tight md:text-6xl dark:text-on-primary">
                Six Strategic
                <span className="text-primary">
                  &nbsp;Service Lines
                </span>
              </h2>
            </div>
            <div className="flex items-start justify-start lg:justify-end">
              <p className="max-w-xl leading-relaxed text-on-surface-2">
                Designed to support clients from strategy to execution, from idea
                validation to product launch, and from infrastructure foundation to
                enterprise-wide digital transformation.
              </p>
            </div>
          </div>
          <div className="mt-20 grid grid-cols-1 gap-6 lg:grid-cols-2">
            <div className="group rounded-2xl border border-surface-3 bg-surface-2 p-5 transition duration-300 hover:border-primary dark:hover:border-[#774c2a] hover:shadow-[0_0_30px_rgba(232,117,26,0.08)]">
              <div className="flex gap-5 cursor-pointer" onClick={()=> toogleServiceExpand("01")}>
                <div className="w-10 h-10 rounded-md flex items-center justify-center flex-shrink-0 mt-0.5" 
                  style={{ backgroundColor: 'rgba(232, 117, 26, 0.094)', border: '1px solid rgba(232, 117, 26, 0.19)'}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                      stroke-linejoin="round" style={{ color: 'rgb(232, 117, 26)'}}>
                        <path d="m18 16 4-4-4-4"></path>
                        <path d="m6 8-4 4 4 4"></path>
                        <path d="m14.5 4-5 16"></path>
                    </svg>
                </div>
                <div className='flex-1'>
                  <div className="flex justify-between">
                    <span className='text-sm font-mono font-bold text-primary'>01</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
                      stroke-linecap="round" stroke-linejoin="round" className="text-[#64748B] transition-transform duration-200 flex-shrink-0 ">
                        <path d="m6 9 6 6 6-6"></path>
                    </svg>
                  </div>
                  <h3 className="font-space font-bold leading-snug dark:text-on-primary">
                    AI-Centric Software Development
                  </h3>
                  <p className="text-sm leading-relaxed text-on-surface-2">
                    Intelligent, scalable, and secure software with AI at the core
                  </p>
                </div>
              </div>
              <div className={`transition-all duration-1000 ease-in-out overflow-hidden ${serviceExpandIndex === '01' ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}>
                <p className="pt-5 text-sm leading-relaxed mb-5">
                  DIGIWORKS develops business-critical software solutions where artificial intelligence, automation, data, and modern engineering practices 
                  are embedded into the architecture from the beginning. This service line covers the full software lifecycle — from business analysis and 
                  solution architecture to UI/UX design, development, AI model integration, quality assurance, deployment, and continuous enhancement.
                </p>
                <div className="mb-4">
                  <div className="font-mono text-[10px] uppercase tracking-widest mb-3">Core Offerings</div>
                  <ul className="grid sm:grid-cols-2 gap-1.5">
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Custom AI-Powered Software Development
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Generative AI &amp; Enterprise Knowledge Solutions
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      AI Chatbots, Virtual Assistants &amp; Agentic Workflows
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Predictive Analytics &amp; Decision Intelligence
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      AI Integration with Existing Software
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      MLOps, Deployment, Monitoring &amp; Support
                    </li>
                  </ul>
                </div>
                <div className="bg-surface-4 text-on-surface-1 rounded-md px-4 py-3">
                  <span className="font-mono text-[10px] uppercase tracking-widest">Target Clients: </span>
                  <span className="text-xs">Enterprises, startups, SMEs, institutions, SaaS businesses</span>
                </div>
              </div>
            </div>
            <div className="group rounded-2xl border border-surface-3 bg-surface-2 p-5 transition duration-300 hover:border-primary dark:hover:border-[#774c2a] hover:shadow-[0_0_30px_rgba(232,117,26,0.08)]">
              <div className="flex gap-5 cursor-pointer" onClick={()=> toogleServiceExpand("02")}>
                <div className="w-10 h-10 rounded-md flex items-center justify-center flex-shrink-0 mt-0.5" 
                  style={{ backgroundColor: 'rgba(123, 159, 255, 0.094)', border: '1px solid rgba(123, 159, 255, 0.19)'}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                      stroke-linejoin="round" style={{ color: 'rgb(123, 159, 255)'}}>
                        <path d="m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z"></path>
                        <path d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65"></path>
                        <path d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65"></path>
                    </svg>
                </div>
                <div className='flex-1'>
                  <div className="flex justify-between">
                    <span className='text-sm font-mono font-bold text-primary'>02</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
                      stroke-linecap="round" stroke-linejoin="round" className="text-[#64748B] transition-transform duration-200 flex-shrink-0 ">
                        <path d="m6 9 6 6 6-6"></path>
                    </svg>
                  </div>
                  <h3 className="font-space font-bold leading-snug dark:text-on-primary">
                    SaaS Innovation & Product Development
                  </h3>
                  <p className="text-sm leading-relaxed text-on-surface-2">
                    Turning validated market problems into scalable SaaS products
                  </p>
                </div>
              </div>
              <div className={`transition-all duration-1000 ease-in-out overflow-hidden ${serviceExpandIndex === '02' ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}>
                <p className="pt-5 text-sm leading-relaxed mb-5">
                  DIGIWORKS follows a problem-first innovation model — identifying recurring operational problems across industries, evaluating market demand, 
                  validating solution concepts with users, building MVPs, and evolving successful products into subscription-based platforms. 
                  A SaaS product should not merely digitize a manual task; it should create measurable value through automation, usability, intelligence, 
                  reliability, and repeatability.
                </p>
                <div className="mb-4">
                  <div className="font-mono text-[10px] uppercase tracking-widest mb-3">Core Offerings</div>
                  <ul className="grid sm:grid-cols-2 gap-1.5">
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Problem Discovery &amp; Market Validation
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      SaaS Product Strategy &amp; Roadmap
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      MVP &amp; Prototype Development
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Cloud-Native SaaS Engineering
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      AI-Enhanced SaaS Features
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Product Scaling &amp; Continuous Improvement
                    </li>
                  </ul>
                </div>
                <div className="bg-surface-4 text-on-surface-1 rounded-md px-4 py-3">
                  <span className="font-mono text-[10px] uppercase tracking-widest">Target Clients: </span>
                  <span className="text-xs">Businesses seeking recurring-revenue products, internal product teams, investors</span>
                </div>
              </div>
            </div>
            <div className="group rounded-2xl border border-surface-3 bg-surface-2 p-5 transition duration-300 hover:border-primary dark:hover:border-[#774c2a] hover:shadow-[0_0_30px_rgba(232,117,26,0.08)]">
              <div className="flex gap-5 cursor-pointer" onClick={()=> toogleServiceExpand("03")}>
                <div className="w-10 h-10 rounded-md flex items-center justify-center flex-shrink-0 mt-0.5" 
                  style={{ backgroundColor: 'rgba(245, 166, 35, 0.094)', border: '1px solid rgba(245, 166, 35, 0.19)'}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                      stroke-linejoin="round" style={{ color: 'rgb(245, 166, 35)'}}>
                        <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                        <path d="M18 17V9"></path><path d="M13 17V5"></path>
                        <path d="M8 17v-3"></path>
                    </svg>
                </div>
                <div className='flex-1'>
                  <div className="flex justify-between">
                    <span className='text-sm font-mono font-bold text-primary'>03</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
                      stroke-linecap="round" stroke-linejoin="round" className="text-[#64748B] transition-transform duration-200 flex-shrink-0 ">
                        <path d="m6 9 6 6 6-6"></path>
                    </svg>
                  </div>
                  <h3 className="font-space font-bold leading-snug dark:text-on-primary">
                    Enterprise Digitization & AI Advisory
                  </h3>
                  <p className="text-sm leading-relaxed text-on-surface-2">
                    Strategic guidance for enterprise transformation and AI adoption
                  </p>
                </div>
              </div>
              <div className={`transition-all duration-1000 ease-in-out overflow-hidden ${serviceExpandIndex === '03' ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}>
                <p className="pt-5 text-sm leading-relaxed mb-5">
                  DIGIWORKS provides consultancy and advisory services for organizations seeking to modernize operations, digitize processes, adopt AI, 
                  and build a structured transformation roadmap. Enterprise digitization requires more than technology deployment — it requires business 
                  process redesign, data readiness, change management, leadership alignment, governance, and phased execution.
                </p>
                <div className="mb-4">
                  <div className="font-mono text-[10px] uppercase tracking-widest mb-3">Core Offerings</div>
                  <ul className="grid sm:grid-cols-2 gap-1.5">
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Digital Maturity Assessment
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Enterprise AI Readiness Assessment
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Digital Transformation Strategy
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      AI Use-Case Discovery &amp; Prioritization
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Process Automation Advisory
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Data Strategy &amp; Governance
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Technology Selection &amp; Architecture Advisory
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      AI Governance, Risk &amp; Compliance
                    </li>
                  </ul>
                </div>
                <div className="bg-surface-4 text-on-surface-1 rounded-md px-4 py-3">
                  <span className="font-mono text-[10px] uppercase tracking-widest">Target Clients: </span>
                  <span className="text-xs">Banks, manufacturers, conglomerates, healthcare, education, government, NGOs</span>
                </div>
              </div>
            </div>
            <div className="group rounded-2xl border border-surface-3 bg-surface-2 p-5 transition duration-300 hover:border-primary dark:hover:border-[#774c2a] hover:shadow-[0_0_30px_rgba(232,117,26,0.08)]">
              <div className="flex gap-5 cursor-pointer" onClick={()=> toogleServiceExpand("04")}>
                <div className="w-10 h-10 rounded-md flex items-center justify-center flex-shrink-0 mt-0.5" 
                  style={{ backgroundColor: 'rgba(16, 185, 129, 0.094)', border: '1px solid rgba(16, 185, 129, 0.19)'}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                      stroke-linejoin="round" style={{ color: 'rgb(16, 185, 129)'}}>
                        <rect width="20" height="8" x="2" y="2" rx="2" ry="2"></rect>
                        <rect width="20" height="8" x="2" y="14" rx="2" ry="2"></rect>
                        <line x1="6" x2="6.01" y1="6" y2="6"></line><line x1="6" x2="6.01" y1="18" y2="18"></line>
                    </svg>
                </div>
                <div className='flex-1'>
                  <div className="flex justify-between">
                    <span className='text-sm font-mono font-bold text-primary'>04</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
                      stroke-linecap="round" stroke-linejoin="round" className="text-[#64748B] transition-transform duration-200 flex-shrink-0 ">
                        <path d="m6 9 6 6 6-6"></path>
                    </svg>
                  </div>
                  <h3 className="font-space font-bold leading-snug dark:text-on-primary">
                    Infrastructure Design & Implementation
                  </h3>
                  <p className="text-sm leading-relaxed text-on-surface-2">
                    Reliable, secure, and future-ready IT environments
                  </p>
                </div>
              </div>
              <div className={`transition-all duration-1000 ease-in-out overflow-hidden ${serviceExpandIndex === '04' ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}>
                <p className="pt-5 text-sm leading-relaxed mb-5">
                  DIGIWORKS provides infrastructure design and implementation services to help organizations build reliable, secure, scalable, and future-ready 
                  IT environments. Strong infrastructure is the foundation for digital transformation, enterprise software, cloud adoption, AI workloads, 
                  cybersecurity, data management, and business continuity. Each engagement includes clear documentation, configuration standards, 
                  support procedures, and knowledge transfer.
                </p>
                <div className="mb-4">
                  <div className="font-mono text-[10px] uppercase tracking-widest mb-3">Core Offerings</div>
                  <ul className="grid sm:grid-cols-2 gap-1.5">
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      IT Infrastructure Assessment
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Network Design &amp; Implementation
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Server &amp; Data Center Infrastructure
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Cloud &amp; Hybrid Infrastructure
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Cybersecurity Infrastructure
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Backup, Disaster Recovery &amp; Business Continuity
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Infrastructure Monitoring &amp; Support
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Enterprise Collaboration &amp; Productivity Platforms
                    </li>
                  </ul>
                </div>
                <div className="bg-surface-4 text-on-surface-1 rounded-md px-4 py-3">
                  <span className="font-mono text-[10px] uppercase tracking-widest">Target Clients: </span>
                  <span className="text-xs">Enterprises, data-heavy organizations, offices, campuses, service providers</span>
                </div>
              </div>
            </div>
            <div className="group rounded-2xl border border-surface-3 bg-surface-2 p-5 transition duration-300 hover:border-primary dark:hover:border-[#774c2a] hover:shadow-[0_0_30px_rgba(232,117,26,0.08)]">
              <div className="flex gap-5 cursor-pointer" onClick={()=> toogleServiceExpand("05")}>
                <div className="w-10 h-10 rounded-md flex items-center justify-center flex-shrink-0 mt-0.5" 
                  style={{ backgroundColor: 'rgba(167, 139, 250, 0.094)', border: '1px solid rgba(167, 139, 250, 0.19)'}}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                    stroke-linejoin="round" style={{ color: 'rgb(167, 139, 250)'}}>
                      <path d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z"></path>
                      <path d="M22 10v6"></path>
                      <path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"></path>
                  </svg>
                </div>
                <div className='flex-1'>
                  <div className="flex justify-between">
                  <span className='text-sm font-mono font-bold text-primary'>05</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
                    stroke-linecap="round" stroke-linejoin="round" className="text-[#64748B] transition-transform duration-200 flex-shrink-0 ">
                      <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
                  <h3 className="font-space font-bold leading-snug dark:text-on-primary">
                    AI Engineering & Consulting Capability Development
                  </h3>
                  <p className="text-sm leading-relaxed text-on-surface-2">
                    Building the next generation of AI engineers and consultants
                  </p>
                </div>
              </div>
              <div className={`transition-all duration-1000 ease-in-out overflow-hidden ${serviceExpandIndex === '05' ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}>
                <p className="pt-5 text-sm leading-relaxed mb-5">
                  DIGIWORKS invests in developing AI engineers and consultants capable of delivering advanced technology solutions locally and internationally. 
                  This service line creates a pipeline of project-ready AI professionals through structured training programs, mentoring, and hands-on delivery 
                  experience — ensuring enterprises can access skilled AI talent for transformation initiatives.
                </p>
                <div className="mb-4">
                  <div className="font-mono text-[10px] uppercase tracking-widest mb-3">Core Offerings</div>
                  <ul className="grid sm:grid-cols-2 gap-1.5">
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      AI Engineer Training &amp; Development Programs
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Consulting Capability Building
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Mentoring &amp; Technical Coaching
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Project-Ready Team Development
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      AI Talent Pipeline for Enterprises
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      International Delivery Capability
                    </li>
                  </ul>
                </div>
                <div className="bg-surface-4 text-on-surface-1 rounded-md px-4 py-3">
                  <span className="font-mono text-[10px] uppercase tracking-widest">Target Clients: </span>
                  <span className="text-xs">DIGIWORKS internal teams, enterprise clients, partner organizations</span>
                </div>
              </div>
            </div>
            <div className="group rounded-2xl border border-surface-3 bg-surface-2 p-5 transition duration-300 hover:border-primary dark:hover:border-[#774c2a] hover:shadow-[0_0_30px_rgba(232,117,26,0.08)]">
              <div className="flex gap-5 cursor-pointer" onClick={()=> toogleServiceExpand("06")}>
                <div className="w-10 h-10 rounded-md flex items-center justify-center flex-shrink-0 mt-0.5" 
                  style={{ backgroundColor: 'rgba(244, 63, 94, 0.094)', border: '1px solid rgba(244, 63, 94, 0.19)'}}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                    stroke-linejoin="round" style={{ color: 'rgb(244, 63, 94)'}}>
                      <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
                      <polyline points="16 7 22 7 22 13"></polyline>
                  </svg>
                </div>
                <div className='flex-1'>
                  <div className="flex justify-between">
                    <span className='text-sm font-mono font-bold text-primary'>06</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
                      stroke-linecap="round" stroke-linejoin="round" className="text-[#64748B] transition-transform duration-200 flex-shrink-0 ">
                        <path d="m6 9 6 6 6-6"></path>
                    </svg>
                  </div>
                  <h3 className="font-space font-bold leading-snug dark:text-on-primary">
                    Strategic Consulting & Market Development
                  </h3>
                  <p className="text-sm leading-relaxed text-on-surface-2">
                    Helping growth-stage IT providers scale and compete
                  </p>
                </div>
              </div>
              <div className={`transition-all duration-1000 ease-in-out overflow-hidden ${serviceExpandIndex === '06' ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}>
                <p className="pt-5 text-sm leading-relaxed mb-5">
                  DIGIWORKS helps growth-stage IT solution providers, software companies, SaaS startups, and system integrators improve their strategy, 
                  positioning, partnerships, and market expansion. This service line is designed for technology companies that have strong delivery capability 
                  but need structured support to convert that capability into sustainable market growth.
                </p>
                <div className="mb-4">
                  <div className="font-mono text-[10px] uppercase tracking-widest mb-3">Core Offerings</div>
                  <ul className="grid sm:grid-cols-2 gap-1.5">
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Growth Strategy &amp; Market Entry Planning
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Go-to-Market Plan Development
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Partner Ecosystem Development
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Sales Enablement &amp; Positioning
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Pricing &amp; Product-Market-Fit Review
                    </li>
                    <li className="flex items-start gap-2 text-xs">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0 bg-primary"></span>
                      Regional Expansion Support
                    </li>
                  </ul>
                </div>
                <div className="bg-surface-4 text-on-surface-1 rounded-md px-4 py-3">
                  <span className="font-mono text-[10px] uppercase tracking-widest">Target Clients: </span>
                  <span className="text-xs">Software companies, IT vendors, SaaS startups, system integrators</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-surface-1 text-on-surface-1 px-6 md:px-12 lg:px-20 py-20" id="products">
        <div className="max-w-[95rem] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <div>
              <p className="text-primary uppercase tracking-[0.3em] text-xs font-mono font-semibold mb-6">
                [03] — Products & Platforms
              </p>
              <h2 className="hidden lg:block text-5xl font-space font-bold leading-tight dark:text-on-primary">
                AI-First Products.&nbsp;
                <span className="text-primary">Market-Disruptive</span>&nbsp;
                Platforms.
              </h2>
              <h2 className="lg:hidden text-4xl font-space font-bold leading-tight dark:text-on-primary">
                AI-First Products.
              </h2>
              <h2 className="lg:hidden text-4xl font-space font-bold leading-tight text-primary">
                Market-Disruptive
              </h2>
              <h2 className="lg:hidden text-4xl font-space font-bold leading-tight dark:text-on-primary">
                Platforms.
              </h2>
            </div>
            <div className="pt-6 lg:pl-20">
              <p className="leading-relaxed max-w-xl">
                DIGIWORKS builds AI-powered products designed to solve real-world challenges and create long-term, scalable impact across industries.
              </p>
            </div>
          </div>
          <div className="mt-16 border border-surface-3 rounded-2xl bg-surface-2 px-6 py-5 flex flex-wrap items-center gap-4">
            <div className="flex items-center gap-2 text-primary text-xs uppercase tracking-[0.2em] font-mono font-semibold">
              <span>⚡</span>
              <span>Shared AI Foundation</span>
            </div>
            <span className="px-4 py-2 rounded-full bg-[#ffe5d1] dark:bg-[#432e1d] border border-primary text-primary text-sm">
              Voice AI
            </span>
            <span className="px-4 py-2 rounded-full bg-[#ffe5d1] dark:bg-[#432e1d] border border-primary text-primary text-sm">
              NLP
            </span>
            <span className="px-4 py-2 rounded-full bg-[#ffe5d1] dark:bg-[#432e1d] border border-primary text-primary text-sm">
              Verification
            </span>
            <span className="px-4 py-2 rounded-full bg-[#ffe5d1] dark:bg-[#432e1d] border border-primary text-primary text-sm">
              Personalization
            </span>
            <span className="px-4 py-2 rounded-full bg-[#ffe5d1] dark:bg-[#432e1d] border border-primary text-primary text-sm">
              Analytics
            </span>
            <span className="px-4 py-2 rounded-full bg-[#ffe5d1] dark:bg-[#432e1d] border border-primary text-primary text-sm">
              Workflow Automation
            </span>
          </div>
          <div className="mt-16">
            <p className="font-mono text-xs uppercase tracking-[0.15em]">
              Current Products & Solutions
            </p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-8">
            <div className="bg-surface-2 border border-surface-3 rounded-2xl p-8 hover:border-primary transition">
              <div className="flex items-start justify-between">
                <div className="flex gap-5">
                  <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" 
                    style={{ backgroundColor: 'rgba(232, 117, 26, 0.094)', border: '1px solid rgba(232, 117, 26, 0.19)'}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
                      stroke-linecap="round" stroke-linejoin="round" style={{ color: 'rgb(232, 117, 26)'}}>
                      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
                    </svg>
                  </div>
                  <div>
                    <p className="text-primary text-xs uppercase tracking-[0.2em] mb-1">
                      01
                    </p>
                    <h3 className="font-space font-bold dark:text-on-primary">
                      Age-Care by AI
                    </h3>
                    <p className="text-xs">
                      Proactive Elderly Care Intelligence
                    </p>
                  </div>
                </div>
                <span className="px-3 py-1 rounded-full bg-green-500/10 border border-green-500/20 text-green-400 text-xs uppercase tracking-[0.2em]">
                  Live
                </span>
              </div>
              <p className="mt-8 leading-relaxed text-sm">
                Proactive elderly-care monitoring, posture intelligence, wearables integration, vitals interpretation, and caregiver support. AI-powered safety monitoring for age-care facilities and home care environments.
              </p>
              <div className="flex flex-wrap gap-3 mt-8">
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  Healthcare
                </span>
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  IoT
                </span>
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  Computer Vision
                </span>
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  Wearables
                </span>
              </div>
            </div>
            <div className="bg-surface-2 border border-surface-3 rounded-2xl p-8 hover:border-primary transition">
              <div className="flex items-start justify-between">
                <div className="flex gap-5">
                  <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" 
                    style={{ backgroundColor: 'rgba(123, 159, 255, 0.094)', border: '1px solid rgba(123, 159, 255, 0.19)'}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
                      stroke-linecap="round" stroke-linejoin="round" style={{ color: 'rgb(123, 159, 255)'}}>
                      <path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2"></path>
                      <path d="M18 14h-8"></path><path d="M15 18h-5"></path>
                      <path d="M10 6h8v4h-8V6Z"></path>
                    </svg>
                  </div>
                  <div>
                    <p className="text-blue-400 text-xs uppercase tracking-[0.2em] mb-1">
                      02
                    </p>
                    <h3 className="font-space font-bold dark:text-on-primary">
                      AI News Agency
                    </h3>
                    <p className="text-xs">
                      Intelligent Media Intelligence Platform
                    </p>
                  </div>
                </div>
                <span className="px-3 py-1 rounded-full bg-green-500/10 border border-green-500/20 text-green-400 text-xs uppercase tracking-[0.2em]">
                  Live
                </span>
              </div>
              <p className="mt-8 leading-relaxed text-sm">
                Aggregated, verified, personalized, and sentiment-aware news intelligence for Bangladesh. Delivers curated, fact-checked content with AI-driven personalization and real-time sentiment analysis.
              </p>
              <div className="flex flex-wrap gap-3 mt-8">
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  NLP
                </span>
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  Sentiment Analysis
                </span>
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  Media
                </span>
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  Personalization
                </span>
              </div>
            </div>
            <div className="bg-surface-2 border border-surface-3 rounded-2xl p-8 hover:border-primary transition">
              <div className="flex items-start justify-between">
                <div className="flex gap-5">
                  <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" 
                    style={{ backgroundColor: 'rgba(16, 185, 129, 0.094)', border: '1px solid rgba(16, 185, 129, 0.19)'}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
                      stroke-linecap="round" stroke-linejoin="round" style={{ color: 'rgb(16, 185, 129)'}}>
                      <path d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z"></path>
                      <path d="M22 10v6"></path>
                      <path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"></path>
                    </svg>
                  </div>
                  <div>
                    <p className="text-emerald-400 text-xs uppercase tracking-[0.2em] mb-1">
                      03
                    </p>
                    <h3 className="font-space font-bold dark:text-on-primary">
                      TVET AI Companion
                    </h3>
                    <p className="text-xs">
                      Voice-First Multilingual Learning
                    </p>
                  </div>
                </div>
                <span className="px-3 py-1 rounded-full bg-green-500/10 border border-green-500/20 text-green-400 text-xs uppercase tracking-[0.2em]">
                  Live
                </span>
              </div>
              <p className="mt-8 leading-relaxed text-sm">
                Voice-first multilingual learning companion for migrant workers, TVET learners, institutions, and employers. Bridges language and skill gaps with AI-powered conversational learning.
              </p>
              <div className="flex flex-wrap gap-3 mt-8">
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  EdTech
                </span>
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  Voice AI
                </span>
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  Multilingual
                </span>
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  NLP
                </span>
              </div>
            </div>
            <div className="bg-surface-2 border border-surface-3 rounded-2xl p-8 hover:border-primary transition">
              <div className="flex items-start justify-between">
                <div className="flex gap-5">
                  <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" 
                    style={{ backgroundColor: 'rgba(167, 139, 250, 0.094)', border: '1px solid rgba(167, 139, 250, 0.19)'}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
                      stroke-linecap="round" stroke-linejoin="round" style={{ color: 'rgb(167, 139, 250)'}}>
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                      <circle cx="9" cy="7" r="4"></circle>
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                    </svg>
                  </div>
                  <div>
                    <p className="text-purple-400 text-xs uppercase tracking-[0.2em] mb-1">
                      04
                    </p>
                    <h3 className="font-space font-bold dark:text-on-primary">
                      HR Recruitment by AI
                    </h3>
                    <p className="text-xs">
                      End-to-End AI Hiring Automation
                    </p>
                  </div>
                </div>
                <span className="px-3 py-1 rounded-full bg-green-500/10 border border-green-500/20 text-green-400 text-xs uppercase tracking-[0.2em]">
                  Live
                </span>
              </div>
              <p className="mt-8 leading-relaxed text-sm">
                AI-assisted CV screening, candidate matching, proactive sourcing, communication, and onboarding workflow. Reduces time-to-hire and improves candidate quality through intelligent automation.
              </p>
              <div className="flex flex-wrap gap-3 mt-8">
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  HR Tech
                </span>
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  AI Screening
                </span>
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  Automation
                </span>
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  Analytics
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-surface-1 text-on-surface-1 px-6 md:px-12 lg:px-20">
        <div className="max-w-[95rem] mx-auto">
          <div className="mb-10">
            <p className="font-mono text-xs uppercase tracking-[0.15em]">
              Upcoming Innovative Platforms — Large-Scale Products Designed For Market Disruption
            </p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="bg-surface-2 border border-surface-3 rounded-2xl p-8 hover:border-primary transition">
              <div className="flex items-start justify-between">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center mb-4" 
                  style={{ backgroundColor: 'rgba(244, 63, 94, 0.094)', border: '1px solid rgba(244, 63, 94, 0.19)'}}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
                    stroke-linecap="round" stroke-linejoin="round" style={{ color: 'rgb(244, 63, 94)'}}>
                    <rect x="3" y="8" width="18" height="4" rx="1"></rect>
                    <path d="M12 8v13"></path>
                    <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"></path>
                    <path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"></path>
                  </svg>
                </div>
                <span className="px-4 py-1 rounded-full bg-[#ffe5d1] dark:bg-[#352519] border border-primary text-primary text-[10px] uppercase tracking-[0.2em] font-semibold">
                  Coming Soon
                </span>
              </div>
              <div className="mt-4">
                <p className="font-mono text-pink-400 text-xs uppercase tracking-[0.2em] mb-2">
                  01
                </p>
                <h3 className="font-space font-bold dark:text-on-primary">
                  StoryBox
                </h3>
                <p className="text-primary font-semibold text-xs">
                  Gifting Reimagined
                </p>
              </div>
              <p className="mt-4 leading-relaxed text-sm">
                AI-assisted gift discovery, emotional storytelling, personalization, premium packaging, corporate gifting, and branded merchandise. Every gift tells a story.
              </p>
              <div className="flex flex-wrap gap-3 mt-10">
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  Emotional Commerce
                </span>
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  AI Personalization
                </span>
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  Corporate Gifting
                </span>
              </div>
            </div>
            <div className="bg-surface-2 border border-surface-3 rounded-2xl p-8 hover:border-primary transition">
              <div className="flex items-start justify-between">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center mb-4" 
                  style={{ backgroundColor: 'rgba(232, 117, 26, 0.094)', border: '1px solid rgba(232, 117, 26, 0.19)'}}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
                    stroke-linecap="round" stroke-linejoin="round" style={{color: 'rgb(232, 117, 26)'}}>
                      <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"></path>
                  </svg>
                </div>
                <span className="px-4 py-1 rounded-full bg-[#ffe5d1] dark:bg-[#352519] border border-primary text-primary text-[10px] uppercase tracking-[0.2em] font-semibold">
                  Coming Soon
                </span>
              </div>
              <div className="mt-4">
                <p className="font-mono text-orange-400 text-xs uppercase tracking-[0.2em] mb-2">
                  02
                </p>
                <h3 className="font-space font-bold dark:text-on-primary">
                  TripNexus
                </h3>
                <p className="text-primary font-semibold text-xs">
                  Travel Intelligence Ecosystem
                </p>
              </div>
              <p className="mt-4 leading-relaxed text-sm">
                Predictive travel intelligence, travel twin, dynamic rebooking, risk scoring, smart tourism, and corporate mobility control. Travel smarter, safer, and more efficiently.
              </p>
              <div className="flex flex-wrap gap-3 mt-10">
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  Travel Tech
                </span>
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  Predictive AI
                </span>
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  Risk Intelligence
                </span>
              </div>
            </div>
            <div className="bg-surface-2 border border-surface-3 rounded-2xl p-8 hover:border-primary transition">
              <div className="flex items-start justify-between">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center mb-4" 
                  style={{ backgroundColor: 'rgba(123, 159, 255, 0.094)', border: '1px solid rgba(123, 159, 255, 0.19)'}}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
                    stroke-linecap="round" stroke-linejoin="round" style={{color: 'rgb(123, 159, 255)'}}>
                    <path d="M8 2v4"></path>
                    <path d="M16 2v4"></path>
                    <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                    <path d="M3 10h18"></path>
                  </svg>
                </div>
                <span className="px-4 py-1 rounded-full bg-[#ffe5d1] dark:bg-[#352519] border border-primary text-primary text-[10px] uppercase tracking-[0.2em] font-semibold">
                  Coming Soon
                </span>
              </div>
              <div className="mt-4">
                <p className="font-mono text-blue-400 text-xs uppercase tracking-[0.2em] mb-2">
                  03
                </p>
                <h3 className="font-space font-bold dark:text-on-primary">
                  EventPilot
                </h3>
                <p className="text-primary font-semibold text-xs">
                  Event Marketplace & Operations
                </p>
              </div>
              <p className="mt-4 leading-relaxed text-sm">
                AI planning co-pilot, vendor matching, budget estimation, risk detection, booking, payments, and event-day coordination. The complete intelligent event operations platform.
              </p>
              <div className="flex flex-wrap gap-3 mt-10">
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  Event Tech
                </span>
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  AI Co-pilot
                </span>
                <span className="px-3 py-1 rounded-md bg-surface-4 border border-surface-3 text-xs">
                  Marketplace
                </span>
              </div>
            </div>
          </div>
          <div className="mt-16 bg-surface-2 border border-surface-3 rounded-2xl p-5 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
            <div>
              <h3 className="font-space font-bold dark:text-on-primary">
                Built for corporate clients, partners, institutions, and investors
              </h3>
              <p className="leading-relaxed max-w-4xl">
                seeking practical AI-led transformation through a commercially diverse, scalable enterprise architecture.
              </p>
            </div>
            <button 
              onClick={(e) => handleScroll(e, 'contact')}
              className="bg-primary hover:opacity-90 transition text-on-primary font-semibold px-10 py-5 rounded-xl shadow-lg shadow-primary/20 whitespace-nowrap">
              Discuss a Product →
            </button>
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden bg-surface-1 py-24 text-on-surface-1 dark:bg-surface-1 dark:text-on-surface-1">
        <div className="relative z-10 mx-auto max-w-[96rem] px-8">
          <div className="max-w-[96rem]">
            <div className="mb-8 flex items-center gap-3">
              <p className="text-xs font-mono font-semibold uppercase tracking-[0.15em] text-primary">
                Value Proposition
              </p>
            </div>
            <h2 className="hidden lg:block text-5xl font-space font-extrabold leading-tight tracking-tight dark:text-on-primary">
              Real Problems. &nbsp;
              <span className="text-primary">
                Practical Solutions.
              </span>
            </h2>
            <h2 className="lg:hidden text-4xl font-space font-extrabold leading-tight tracking-tight dark:text-on-primary">
              Real Problems.
            </h2>
            <h2 className="lg:hidden text-4xl font-space font-extrabold leading-tight tracking-tight text-primary">
              Practical Solutions.
            </h2>
            <p className="mt-10 max-w-4xl leading-relaxed text-on-surface-2">
              DIGIWORKS delivers value by combining business understanding,
              AI-native engineering, infrastructure capability, and consulting
              discipline — focusing on measurable business outcomes, not
              technology for its own sake.
            </p>
          </div>
          <div className="mt-20 overflow-hidden rounded-3xl border border-surface-3 bg-surface-2 backdrop-blur-sm">
            <div className="grid grid-cols-1 border-b border-surface-3 md:grid-cols-3">
              <div className="border-b border-surface-3 px-4 py-4 md:border-b-0 md:border-r">
                <p className="text-xs font-mono font-bold uppercase tracking-[0.15em] text-[#f43f5e]">
                  Client Challenge
                </p>
              </div>
              <div className="border-b border-surface-3 px-4 py-4 md:border-b-0 md:border-r">
                <p className="text-xs font-mono font-bold uppercase tracking-[0.15em] text-primary">
                  DIGIWORKS Response
                </p>
              </div>
              <div className="px-4 py-4">
                <p className="text-xs font-mono font-bold uppercase tracking-[0.15em] text-emerald-400">
                  Business Value
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 border-b border-surface-3 md:grid-cols-3">
              <div className="border-b border-surface-3 px-4 py-4 font-semibold text-on-surface-1 md:border-b-0 md:border-r">
                Manual & repetitive business processes
              </div>
              <div className="border-b border-surface-3 px-4 py-4 text-on-surface-2/75 md:border-b-0 md:border-r">
                Workflow automation and AI-assisted operations
              </div>
              <div className="px-4 py-4 font-semibold text-emerald-400">
                Faster turnaround, fewer errors, reduced operating cost
              </div>
            </div>
            <div className="grid grid-cols-1 border-b border-surface-3 md:grid-cols-3">
              <div className="border-b border-surface-3 px-4 py-4 font-semibold text-on-surface-1 md:border-b-0 md:border-r">
                Fragmented data across departments
              </div>
              <div className="border-b border-surface-3 px-4 py-4 text-on-surface-2/75 md:border-b-0 md:border-r">
                Integrated databases, APIs, data pipelines, and dashboards
              </div>
              <div className="px-4 py-4 font-semibold text-emerald-400">
                Better visibility and improved decision-making
              </div>
            </div>
            <div className="grid grid-cols-1 border-b border-surface-3 md:grid-cols-3">
              <div className="border-b border-surface-3 px-4 py-4 font-semibold text-on-surface-1 md:border-b-0 md:border-r">
                Legacy systems with limited flexibility
              </div>
              <div className="border-b border-surface-3 px-4 py-4 text-on-surface-2/75 md:border-b-0 md:border-r">
                Modernization, refactoring, and cloud-ready architecture
              </div>
              <div className="px-4 py-4 font-semibold text-emerald-400">
                Improved performance, scalability, and maintainability
              </div>
            </div>
            <div className="grid grid-cols-1 border-b border-surface-3 md:grid-cols-3">
              <div className="border-b border-surface-3 px-4 py-4 font-semibold text-on-surface-1 md:border-b-0 md:border-r">
                Slow customer support or service delivery
              </div>
              <div className="border-b border-surface-3 px-4 py-4 text-on-surface-2/75 md:border-b-0 md:border-r">
                AI chatbots, virtual assistants, and case-routing systems
              </div>
              <div className="px-4 py-4 font-semibold text-emerald-400">
                Improved customer experience and 24/7 support capability
              </div>
            </div>
            <div className="grid grid-cols-1 border-b border-surface-3 md:grid-cols-3">
              <div className="border-b border-surface-3 px-4 py-4 font-semibold text-on-surface-1 md:border-b-0 md:border-r">
                Complex document-heavy operations
              </div>
              <div className="border-b border-surface-3 px-4 py-4 text-on-surface-2/75 md:border-b-0 md:border-r">
                OCR, document intelligence, summarization, and classification
              </div>
              <div className="px-4 py-4 font-semibold text-emerald-400">
                Reduced paperwork and stronger compliance control
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3">
              <div className="border-b border-surface-3 px-4 py-4 font-semibold text-on-surface-1 md:border-b-0 md:border-r">
                Limited predictive insight
              </div>
              <div className="border-b border-surface-3 px-4 py-4 text-on-surface-2/75 md:border-b-0 md:border-r">
                Machine learning, forecasting, risk scoring, and analytics
              </div>
              <div className="px-4 py-4 font-semibold text-emerald-400">
                Proactive planning and smarter business decisions
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-surface-1 text-on-surface-1 py-20 px-6 md:px-12 lg:px-20" id="competency">
        <div className="max-w-[95rem] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start mb-14">
            <div>
              <p className="text-primary uppercase tracking-[0.3em] text-xs font-mono font-semibold mb-6">
                [04] — Agentic AI Competency
              </p>
              <h1 className="text-4xl lg:text-5xl font-space font-bold leading-tight max-w-3xl dark:text-on-primary">
                The&nbsp;
                <span className="text-primary">"Last Mile"</span>
                &nbsp;AI <br />
                Implementation Experts
              </h1>
            </div>
            <div className="lg:pt-16">
              <p className="text-on-secondary/70 leading-relaxed max-w-xl">
                Modern businesses do not need more AI models — they need experts who
                can connect existing AI capabilities to real workflows, data sources,
                and enterprise systems.
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <div className="space-y-6">
              <div className="bg-surface-2 border border-surface-3 rounded-2xl p-8">
                <p className="text-primary uppercase tracking-[0.25em] text-xs font-mono font-semibold mb-6">
                  Core Philosophy
                </p>
                <h3 className="text-3xl font-space font-bold leading-snug mb-6">
                  80% Implementation & Integration. 20% Custom Logic.
                </h3>
                <p className="text-on-surface-1 leading-relaxed">
                  We allocate resources strategically, dedicating the majority of
                  effort to integration and implementation, delivering robust,
                  scalable, and highly customized AI solutions that address the unique
                  challenges of each client.
                </p>
              </div>
              <div className="bg-surface-2 border border-surface-3 rounded-2xl p-5 flex items-start gap-5">
                <div className="w-8 h-8 rounded flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(232, 117, 26, 0.094)'}}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                    stroke-linejoin="round" style={{ color: 'rgb(232, 117, 26)'}}>
                      <line x1="6" x2="6" y1="3" y2="15"></line>
                      <circle cx="18" cy="6" r="3"></circle>
                      <circle cx="6" cy="18" r="3"></circle>
                      <path d="M18 9a9 9 0 0 1-9 9"></path>
                  </svg>
                </div>
                <div>
                  <h4 className="font-space font-semibold mb-2 dark:text-on-primary">Integration</h4>
                  <p className="text-xs leading-relaxed">
                    We connect AI to existing workflows, ensuring solutions enhance
                    rather than disrupt current operations.
                  </p>
                </div>
              </div>
              <div className="bg-surface-2 border border-surface-3 rounded-2xl p-5 flex items-start gap-5">
                <div className="w-8 h-8 rounded flex items-center justify-center flex-shrink-0" 
                  style={{ backgroundColor: 'rgba(123, 159, 255, 0.094)'}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                      stroke-linejoin="round" style={{ color: 'rgb(123, 159, 255)'}}>
                        <rect width="16" height="16" x="4" y="4" rx="2"></rect>
                        <rect width="6" height="6" x="9" y="9" rx="1"></rect>
                        <path d="M15 2v2"></path>
                        <path d="M15 20v2"></path>
                        <path d="M2 15h2"></path>
                        <path d="M2 9h2"></path>
                        <path d="M20 15h2"></path>
                        <path d="M20 9h2"></path>
                        <path d="M9 2v2"></path>
                        <path d="M9 20v2"></path>
                    </svg>
                </div>
                <div>
                  <h4 className="font-space font-semibold mb-2 dark:text-on-primary">MCP Connectors</h4>
                  <p className="text-xs leading-relaxed">
                    We standardize data access through Model Context Protocol
                    connectors, enabling secure communication between AI agents and
                    enterprise systems.
                  </p>
                </div>
              </div>
              <div className="bg-surface-2 border border-surface-3 rounded-2xl p-5 flex items-start gap-5">
                <div className="w-8 h-8 rounded flex items-center justify-center flex-shrink-0" 
                  style={{ backgroundColor: 'rgba(245, 166, 35, 0.094)'}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                    stroke-linejoin="round" style={{ color: 'rgb(245, 166, 35)'}}>
                      <path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"></path>
                      <path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z"></path>
                      <path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4"></path>
                      <path d="M17.599 6.5a3 3 0 0 0 .399-1.375"></path>
                      <path d="M6.003 5.125A3 3 0 0 0 6.401 6.5"></path>
                      <path d="M3.477 10.896a4 4 0 0 1 .585-.396"></path>
                      <path d="M19.938 10.5a4 4 0 0 1 .585.396"></path>
                      <path d="M6 18a4 4 0 0 1-1.967-.516"></path>
                      <path d="M19.967 17.484A4 4 0 0 1 18 18"></path>
                    </svg>
                </div>
                <div>
                  <h4 className="font-space font-semibold mb-2 dark:text-on-primary">Business Logic</h4>
                  <p className="text-xs leading-relaxed">
                    We tailor agent reasoning to meet specific business needs,
                    ensuring AI solutions align with clients' strategic objectives.
                  </p>
                </div>
              </div>
            </div>
            <div className="relative">
              <div className="overflow-hidden rounded-3xl border border-white/10 bg-surface-1/5">
                <img
                  src={AgenticAiVisual}
                  alt="AI Network"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-surface-1 text-on-surface-1 py-20 px-6 md:px-12 lg:px-20">
        <div className="max-w-[95rem] mx-auto">
          <div className="mb-20">
            <p className="text-xs uppercase tracking-[0.15em] font-mono mb-10">
              Technical Architecture
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
              <div className="bg-surface-2 border border-surface-3 rounded-2xl p-4 transition duration-300 hover:-translate-y-1 hover:border-[#774c2a]">
                <p className="text-primary uppercase tracking-[0.25em] text-xs font-semibold mb-2">
                  Orchestration
                </p>
                <p className="mb-8 text-xs">The Brain</p>
                <div className="space-y-7">
                  <div className="border-l border-primary pl-4">
                    <h3 className="font-space font-semibold mb-1 dark:text-on-primary">LangGraph / CrewAI</h3>
                    <p className="text-xs leading-relaxed">
                      Multi-agent workflows & state management
                    </p>
                  </div>
                  <div className="border-l border-primary pl-4">
                    <h3 className="font-space font-semibold mb-1 dark:text-on-primary">AutoGen 2.0</h3>
                    <p className="text-xs leading-relaxed">
                      Agent-to-agent conversations & collaboration
                    </p>
                  </div>
                  <div className="border-l border-primary pl-4">
                    <h3 className="font-space font-semibold mb-1 dark:text-on-primary">State Management</h3>
                    <p className="text-xs leading-relaxed">
                      Context across long-running business processes
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-surface-2 border border-surface-3 rounded-2xl p-4 transition duration-300 hover:-translate-y-1 hover:border-[#774c2a]">
                <p className="text-blue-400 uppercase tracking-[0.25em] text-xs font-semibold mb-2">
                  Intelligence
                </p>
                <p className="mb-8 text-xs">Thinking Power</p>
                <div className="space-y-7">
                  <div className="border-l border-blue-400/40 pl-4">
                    <h3 className="font-space font-semibold mb-1 dark:text-on-primary">GPT-5.4</h3>
                    <p className="text-xs leading-relaxed">
                      Structured logic and precise tool use
                    </p>
                  </div>
                  <div className="border-l border-blue-400/40 pl-4">
                    <h3 className="font-space font-semibold mb-1 dark:text-on-primary">Claude 4.6</h3>
                    <p className="text-xs leading-relaxed">
                      Advanced reasoning and complex coding
                    </p>
                  </div>
                  <div className="border-l border-blue-400/40 pl-4">
                    <h3 className="font-space font-semibold mb-1 dark:text-on-primary">Gemini 3.1 Pro</h3>
                    <p className="text-xs leading-relaxed">
                      Massive context handling (2M+ tokens)
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-surface-2 border border-surface-3 rounded-2xl p-4 transition duration-300 hover:-translate-y-1 hover:border-[#774c2a]">
                <p className="text-emerald-400 uppercase tracking-[0.25em] text-xs font-semibold mb-2">
                  Tooling & Context
                </p>
                <p className="mb-8 text-xs">Capabilities & Memory</p>
                <div className="space-y-7">
                  <div className="border-l border-emerald-400/40 pl-4">
                    <h3 className="font-space font-semibold mb-1 dark:text-on-primary">MCP (Model Context Protocol)</h3>
                    <p className="text-xs leading-relaxed">
                      Standardized connectivity to enterprise systems
                    </p>
                  </div>
                  <div className="border-l border-emerald-400/40 pl-4">
                    <h3 className="font-space font-semibold mb-1 dark:text-on-primary">Vector Databases</h3>
                    <p className="text-xs leading-relaxed">
                      Pinecone, Weaviate, Chroma for semantic search & RAG
                    </p>
                  </div>
                  <div className="border-l border-emerald-400/40 pl-4">
                    <h3 className="font-space font-semibold mb-1 dark:text-on-primary">Custom MCP Connectors</h3>
                    <p className="text-xs leading-relaxed">
                      Bridges for Postgres, Slack, Jira, legacy systems
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.15em] font-mono mb-10">
              High-ROI Horizontal Services
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
              <div className="bg-surface-2 border border-surface-3 rounded-2xl p-4 transition duration-300 hover:-translate-y-1 hover:border-[#774c2a]">
                <div className="w-8 h-8 rounded bg-[#E8751A]/10 flex items-center justify-center mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                    stroke-linejoin="round" className="text-[#E8751A]">
                      <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"></path>
                  </svg>
                </div>
                <h3 className="font-space font-semibold mb-4 dark:text-on-primary">
                  Multi-Agent Sales Pipeline
                </h3>
                <p className="text-xs leading-relaxed">
                  End-to-end automation from lead qualification and data enrichment to
                  personalized outreach and CRM synchronization.
                </p>
              </div>
              <div className="bg-surface-2 border border-surface-3 rounded-2xl p-4 transition duration-300 hover:-translate-y-1 hover:border-[#774c2a]">
                <div className="w-8 h-8 rounded bg-[#E8751A]/10 flex items-center justify-center mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
                    stroke-linecap="round" stroke-linejoin="round" className="text-[#E8751A]">
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  </svg>
                </div>
                <h3 className="font-space font-semibold mb-4 dark:text-on-primary">
                  Intelligent Support Agents
                </h3>
                <p className="text-xs leading-relaxed">
                  24/7 autonomous helpdesks integrated with Zendesk, Slack, and Email
                  for instant, context-aware resolution.
                </p>
              </div>
              <div className="bg-surface-2 border border-surface-3 rounded-2xl p-4 transition duration-300 hover:-translate-y-1 hover:border-[#774c2a]">
                <div className="w-8 h-8 rounded bg-[#E8751A]/10 flex items-center justify-center mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
                    stroke-linecap="round" stroke-linejoin="round" className="text-[#E8751A]">
                      <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                      <path d="M3 5V19A9 3 0 0 0 21 19V5"></path>
                      <path d="M3 12A9 3 0 0 0 21 12"></path>
                  </svg>
                </div>
                <h3 className="font-space font-semibold mb-4 dark:text-on-primary">
                  Internal Ops Automation
                </h3>
                <p className="text-xs leading-relaxed">
                  Invoice processing, HR onboarding, and automated executive report
                  generation — freeing teams for strategic work.
                </p>
              </div>
              <div className="bg-surface-2 border border-surface-3 rounded-2xl p-4 transition duration-300 hover:-translate-y-1 hover:border-[#774c2a]">
                <div className="w-8 h-8 rounded bg-[#E8751A]/10 flex items-center justify-center mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
                    stroke-linecap="round" stroke-linejoin="round" className="text-[#E8751A]">
                      <path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"></path>
                      <path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z"></path>
                      <path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4"></path>
                      <path d="M17.599 6.5a3 3 0 0 0 .399-1.375"></path>
                      <path d="M6.003 5.125A3 3 0 0 0 6.401 6.5"></path>
                      <path d="M3.477 10.896a4 4 0 0 1 .585-.396"></path>
                      <path d="M19.938 10.5a4 4 0 0 1 .585.396"></path>
                      <path d="M6 18a4 4 0 0 1-1.967-.516"></path>
                      <path d="M19.967 17.484A4 4 0 0 1 18 18"></path>
                  </svg>
                </div>
                <h3 className="font-space font-semibold mb-4 dark:text-on-primary">
                  Data & Decision Agents
                </h3>
                <p className="text-xs leading-relaxed">
                  Agents that pull from databases and APIs to provide real-time
                  insights and trigger automated business actions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-surface-1 text-on-surface-1 py-20 px-6 md:px-12 lg:px-20">
        <div className="max-w-[95rem] mx-auto">
          <p className="text-xs uppercase tracking-[0.15em] font-mono mb-10">
            Agentic Delivery Unit — Team Structure
          </p>
          <div className="overflow-hidden rounded-2xl border border-surface-3 bg-surface-2">
            <div className="hidden lg:grid grid-cols-12 border-b border-white/10 px-6 py-5">
              <div className="col-span-4">
                <p className="font-mono text-[11px] uppercase tracking-[0.15em]">
                  Role
                </p>
              </div>
              <div className="col-span-4">
                <p className="font-mono text-[11px] uppercase tracking-[0.15em]">
                  Responsibilities
                </p>
              </div>
              <div className="col-span-4">
                <p className="font-mono text-[11px] uppercase tracking-[0.15em]">
                  Key Technologies
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 p-4 border-b border-surface-3">
              <div className="lg:col-span-4">
                <h3 className="font-space font-semibold dark:text-on-primary">Architect / Team Lead</h3>
              </div>
              <div className="lg:col-span-4">
                <p className="text-xs leading-relaxed">
                  Client discovery, high-value use-case identification, agent graph
                  design, business ROI alignment.
                </p>
              </div>
              <div className="lg:col-span-4">
                <p className="text-primary text-xs leading-relaxed fotn-medium">
                  LangGraph (Adv), LangSmith, Arize Phoenix, Docker, K8s, AWS,
                  Terraform
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 p-4 border-b border-surface-3">
              <div className="lg:col-span-4">
                <h3 className="font-space font-semibold dark:text-on-primary">Agent Logic Engineers</h3>
              </div>
              <div className="lg:col-span-4">
                <p className="text-xs leading-relaxed">
                  Multi-agent workflow design, state management, decision logic,
                  reliable reasoning chains.
                </p>
              </div>
              <div className="lg:col-span-4">
                <p className="text-primary text-xs leading-relaxed fotn-medium">
                  LangGraph, CrewAI, Pydantic AI, Next.js, Tailwind CSS, Vercel AI SDK
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 px-6 py-8 p-4 border-b border-surface-3">
              <div className="lg:col-span-4">
                <h3 className="font-space font-semibold dark:text-on-primary">
                  MCP & Integration Engineers
                </h3>
              </div>
              <div className="lg:col-span-4">
                <p className="text-xs leading-relaxed">
                  Connect AI to real systems via MCP, develop custom connectors and
                  secure API bridges.
                </p>
              </div>
              <div className="lg:col-span-4">
                <p className="text-primary text-xs leading-relaxed fotn-medium">
                  MCP SDKs (Python/TS), MCP Inspector, Custom MCP Servers, FastAPI,
                  Vector DBs
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 p-4">
              <div className="lg:col-span-4">
                <h3 className="font-space font-semibold dark:text-on-primary">UI/UX Engineers</h3>
              </div>
              <div className="lg:col-span-4">
                <p className="text-xs leading-relaxed">
                  Intuitive dashboards and Human-in-the-Loop (HITL) controls for
                  complex autonomous systems.
                </p>
              </div>
              <div className="lg:col-span-4">
                <p className="text-primary text-xs leading-relaxed fotn-medium">
                  Next.js, Tailwind CSS, Vercel AI SDK, HITL Interface Design
                </p>
              </div>
            </div>
          </div>
          <div className="flex justify-center mt-10">
            <div className="border border-primary bg-surface-2 rounded-lg px-4 py-4">
              <p className="text-primary text-center font-mono font-medium tracking-wide">
                "We don't just use AI; we build agents that build software."
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-surface-4 text-on-surface-1 px-6 md:px-12 lg:px-20 py-20" id="methodology">
        <div className="max-w-[95rem] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <div>
              <p className="text-primary uppercase tracking-[0.3em] text-xs font-mono font-semibold mb-6">
                [05] — Delivery Methodology
              </p>
              <h2 className="hidden lg:block text-5xl font-space font-bold leading-tight dark:text-on-primary">
                From Strategy to&nbsp;
                <span className="text-primary">Last-Mile</span>
                <br />
                Implementation
              </h2>
              <h2 className="text-4xl lg:hidden font-space font-bold leading-tight dark:text-on-primary">
                From Strategy to
              </h2>
              <h2 className="text-4xl lg:hidden font-space font-bold leading-tight text-primary">
                Last-Mile
              </h2>
              <h2 className="text-4xl lg:hidden font-space font-bold leading-tight dark:text-on-primary">
                Implementation
              </h2>
            </div>
            <div className="pt-4">
              <p className="leading-relaxed max-w-xl">
                A structured six-stage process ensuring every engagement delivers measurable outcomes — from initial discovery through continuous optimisation.
              </p>
            </div>
          </div>
          <div className="hidden lg:block mt-5 mb-8 transition-all duration-700 delay-200 opacity-100 translate-y-0">
            <div className="relative">
              <div className="absolute top-8 left-[7%] right-[7%] h-px bg-gradient-to-r from-transparent via-[#E8751A]/30 to-transparent"></div>
              <div className="grid grid-cols-6 gap-2">
                <button className="flex flex-col items-center gap-3 pt-2 pb-4 px-2 rounded-xl transition-all duration-200 group bg-surface-1 dark:bg-surface-2 border border-surface-3"
                  onClick={() => setStage("discover")}
                  >
                  <div className={
                    stage === "discover" ? "w-14 h-14 rounded-full flex items-center justify-center border-2 transition-all duration-200 border-primary bg-[#E8751A]/15"
                    : "w-14 h-14 rounded-full flex items-center justify-center border-2 transition-all duration-200 border-[#94A3B8] dark:border-on-surface-1 group-hover:border-primary bg-[#E8751A]/15" }
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
                      stroke-linecap="round" stroke-linejoin="round" className={
                        stage === "discover" ? "transition-colors duration-200 text-primary" 
                        : "transition-colors duration-200 text-[#94A3B8] dark:text-on-surface-1 group-hover:text-primary"}>
                        <circle cx="11" cy="11" r="8"></circle>
                        <path d="m21 21-4.3-4.3"></path>
                    </svg>
                  </div>
                  <div className="text-center">
                    <div className={
                      stage === "discover" ? "font-mono text-[10px] uppercase tracking-widest mb-1 transition-colors text-primary"
                      : "font-mono text-[10px] uppercase tracking-widest mb-1 transition-colors text-on-surface-1 group-hover:text-primary"}>01</div>
                    <div className={
                      stage === "discover" ? "text-sm font-bold transition-colors dark:text-on-primary"
                      : "text-sm font-bold transition-colors text-[#94A3B8] dark:text-on-surface-1 group-hover:text-on-surface-1 group-hover:dark:text-on-primary"}>Discover</div>
                  </div>
                </button>
                <button className="flex flex-col items-center gap-3 pt-2 pb-4 px-2 rounded-xl transition-all duration-200 group bg-surface-1 dark:bg-surface-2 border border-surface-3"
                  onClick={() => setStage("design")}>
                  <div className={
                    stage === "design" ? "w-14 h-14 rounded-full flex items-center justify-center border-2 transition-all duration-200 border-primary bg-[#E8751A]/15"
                    : "w-14 h-14 rounded-full flex items-center justify-center border-2 transition-all duration-200 border-[#94A3B8] dark:border-on-surface-1 group-hover:border-primary bg-[#E8751A]/15" }
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                      stroke-linejoin="round" className={
                        stage === "design" ? "transition-colors duration-200 text-primary" 
                        : "transition-colors duration-200 text-[#94A3B8] dark:text-on-surface-1 group-hover:text-primary"}>
                        <path d="m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z"></path>
                        <circle cx="12" cy="12" r="10"></circle>
                    </svg>
                  </div>
                  <div className="text-center">
                    <div className={
                      stage === "design" ? "font-mono text-[10px] uppercase tracking-widest mb-1 transition-colors text-primary"
                      : "font-mono text-[10px] uppercase tracking-widest mb-1 transition-colors text-on-surface-1 group-hover:text-primary"}>02</div>
                    <div className={
                      stage === "design" ? "text-sm font-bold transition-colors dark:text-on-primary"
                      : "text-sm font-bold transition-colors text-[#94A3B8] dark:text-on-surface-1 group-hover:text-on-surface-1 group-hover:dark:text-on-primary"}>Design</div>
                  </div>
                </button>
                <button className="flex flex-col items-center gap-3 pt-2 pb-4 px-2 rounded-xl transition-all duration-200 group bg-surface-1 dark:bg-surface-2 border border-surface-3"
                  onClick={() => setStage("develop")}>
                  <div className={
                    stage === "develop" ? "w-14 h-14 rounded-full flex items-center justify-center border-2 transition-all duration-200 border-primary bg-[#E8751A]/15"
                    : "w-14 h-14 rounded-full flex items-center justify-center border-2 transition-all duration-200 border-[#94A3B8] dark:border-on-surface-1 group-hover:border-primary bg-[#E8751A]/15" }
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                      stroke-linejoin="round" className={
                        stage === "develop" ? "transition-colors duration-200 text-primary" 
                        : "transition-colors duration-200 text-[#94A3B8] dark:text-on-surface-1 group-hover:text-primary"}>
                        <path d="m18 16 4-4-4-4"></path>
                        <path d="m6 8-4 4 4 4"></path>
                        <path d="m14.5 4-5 16"></path>
                    </svg>
                  </div>
                  <div className="text-center">
                    <div className={
                      stage === "develop" ? "font-mono text-[10px] uppercase tracking-widest mb-1 transition-colors text-primary"
                      : "font-mono text-[10px] uppercase tracking-widest mb-1 transition-colors text-on-surface-1 group-hover:text-primary"}>03</div>
                    <div className={
                      stage === "develop" ? "text-sm font-bold transition-colors dark:text-on-primary"
                      : "text-sm font-bold transition-colors text-[#94A3B8] dark:text-on-surface-1 group-hover:text-on-surface-1 group-hover:dark:text-on-primary"}>Develop</div>
                  </div>
                </button>
                <button className="flex flex-col items-center gap-3 pt-2 pb-4 px-2 rounded-xl transition-all duration-200 group bg-surface-1 dark:bg-surface-2 border border-surface-3"
                  onClick={() => setStage("validate")}>
                  <div className={
                    stage === "validate" ? "w-14 h-14 rounded-full flex items-center justify-center border-2 transition-all duration-200 border-primary bg-[#E8751A]/15"
                    : "w-14 h-14 rounded-full flex items-center justify-center border-2 transition-all duration-200 border-[#94A3B8] dark:border-on-surface-1 group-hover:border-primary bg-[#E8751A]/15" }
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                      stroke-linejoin="round" className={
                        stage === "validate" ? "transition-colors duration-200 text-primary" 
                        : "transition-colors duration-200 text-[#94A3B8] dark:text-on-surface-1 group-hover:text-primary"}>
                        <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                        <path d="m9 12 2 2 4-4"></path>
                    </svg>
                  </div>
                  <div className="text-center">
                    <div className={
                      stage === "validate" ? "font-mono text-[10px] uppercase tracking-widest mb-1 transition-colors text-primary"
                      : "font-mono text-[10px] uppercase tracking-widest mb-1 transition-colors text-on-surface-1 group-hover:text-primary"}>04</div>
                    <div className={
                      stage === "validate" ? "text-sm font-bold transition-colors dark:text-on-primary"
                      : "text-sm font-bold transition-colors text-[#94A3B8] dark:text-on-surface-1 group-hover:text-on-surface-1 group-hover:dark:text-on-primary"}>Validate</div>
                  </div>
                </button>
                <button className="flex flex-col items-center gap-3 pt-2 pb-4 px-2 rounded-xl transition-all duration-200 group bg-surface-1 dark:bg-surface-2 border border-surface-3"
                  onClick={() => setStage("deploy")}>
                  <div className={
                    stage === "deploy" ? "w-14 h-14 rounded-full flex items-center justify-center border-2 transition-all duration-200 border-primary bg-[#E8751A]/15"
                    : "w-14 h-14 rounded-full flex items-center justify-center border-2 transition-all duration-200 border-[#94A3B8] dark:border-on-surface-1 group-hover:border-primary bg-[#E8751A]/15" }
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                      stroke-linejoin="round" className={
                        stage === "deploy" ? "transition-colors duration-200 text-primary" 
                        : "transition-colors duration-200 text-[#94A3B8] dark:text-on-surface-1 group-hover:text-primary"}>
                        <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"></path>
                        <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"></path>
                        <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"></path>
                        <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"></path>
                    </svg>
                  </div>
                  <div className="text-center">
                    <div className={
                      stage === "deploy" ? "font-mono text-[10px] uppercase tracking-widest mb-1 transition-colors text-primary"
                      : "font-mono text-[10px] uppercase tracking-widest mb-1 transition-colors text-on-surface-1 group-hover:text-primary"}>05</div>
                    <div className={
                      stage === "deploy" ? "text-sm font-bold transition-colors dark:text-on-primary"
                      : "text-sm font-bold transition-colors text-[#94A3B8] dark:text-on-surface-1 group-hover:text-on-surface-1 group-hover:dark:text-on-primary"}>Deploy</div>
                  </div>
                </button>
                <button className="flex flex-col items-center gap-3 pt-2 pb-4 px-2 rounded-xl transition-all duration-200 group bg-surface-1 dark:bg-surface-2 border border-surface-3"
                  onClick={() => setStage("optimize")}>
                  <div className={
                    stage === "optimize" ? "w-14 h-14 rounded-full flex items-center justify-center border-2 transition-all duration-200 border-primary bg-[#E8751A]/15"
                    : "w-14 h-14 rounded-full flex items-center justify-center border-2 transition-all duration-200 border-[#94A3B8] dark:border-on-surface-1 group-hover:border-primary bg-[#E8751A]/15" }
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                      stroke-linejoin="round" className={
                        stage === "optimize" ? "transition-colors duration-200 text-primary" 
                        : "transition-colors duration-200 text-[#94A3B8] dark:text-on-surface-1 group-hover:text-primary"}>
                        <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
                        <polyline points="16 7 22 7 22 13"></polyline>
                    </svg>
                  </div>
                  <div className="text-center">
                    <div className={
                      stage === "optimize" ? "font-mono text-[10px] uppercase tracking-widest mb-1 transition-colors text-primary"
                      : "font-mono text-[10px] uppercase tracking-widest mb-1 transition-colors text-on-surface-1 group-hover:text-primary"}>06</div>
                    <div className={
                      stage === "optimize" ? "text-sm font-bold transition-colors dark:text-on-primary"
                      : "text-sm font-bold transition-colors text-[#94A3B8] dark:text-on-surface-1 group-hover:text-on-surface-1 group-hover:dark:text-on-primary"}>Optimize</div>
                  </div>
                </button>
              </div>
            </div>
            { stage === "discover" && 
            <div className="mt-6 bg-surface-1 dark:bg-surface-2 text-on-surface-1 border border-surface-3 rounded-xl p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#E8751A]/10 flex items-center justify-center flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                    stroke-linejoin="round" className="text-primary">
                      <circle cx="11" cy="11" r="8"></circle>
                      <path d="m21 21-4.3-4.3"></path>
                  </svg>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="font-mono text-[10px] text-primary uppercase tracking-widest">Stage 01</span>
                    <span className="font-display dark:text-on-primary text-lg font-bold">Discover</span>
                    <span className="text-sm">— Discover Problems</span>
                  </div>
                  <p className="text-sm leading-relaxed mb-4 max-w-3xl">
                    Deep-dive into your business context, pain points, existing systems, and strategic goals. Define the problem before proposing any solution.
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Discovery report</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Problem definition</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Opportunity map</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Requirement baseline</span>
                  </div>
                </div>
              </div>
            </div>}
            { stage === "design" && 
            <div className="mt-6 bg-surface-1 dark:bg-surface-2 text-on-surface-1 border border-surface-3 rounded-xl p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#E8751A]/10 flex items-center justify-center flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                    stroke-linejoin="round" className="text-primary">
                      <path d="m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z"></path>
                      <circle cx="12" cy="12" r="10"></circle>
                  </svg>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="font-mono text-[10px] text-primary uppercase tracking-widest">Stage 02</span>
                    <span className="font-display dark:text-on-primary text-lg font-bold">Design</span>
                    <span className="text-sm">— Design Blueprint</span>
                  </div>
                  <p className="text-sm leading-relaxed mb-4 max-w-3xl">
                    Architect the solution — defining the technical blueprint, data flows, AI model strategy, integration points, and user experience.
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Solution blueprint</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Architecture design</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Roadmap</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Implementation plan</span>
                  </div>
                </div>
              </div>
            </div>}
            { stage === "develop" && 
            <div className="mt-6 bg-surface-1 dark:bg-surface-2 text-on-surface-1 border border-surface-3 rounded-xl p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#E8751A]/10 flex items-center justify-center flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                    stroke-linejoin="round" className="text-primary">
                      <path d="m18 16 4-4-4-4"></path>
                      <path d="m6 8-4 4 4 4"></path>
                      <path d="m14.5 4-5 16"></path>
                  </svg>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="font-mono text-[10px] text-primary uppercase tracking-widest">Stage 03</span>
                    <span className="font-display dark:text-on-primary text-lg font-bold">Develop</span>
                    <span className="text-sm">— Develop Solution</span>
                  </div>
                  <p className="text-sm leading-relaxed mb-4 max-w-3xl">
                    Agile, AI-first development with continuous integration and modular architecture. Build iteratively with regular demos and progress checkpoints.
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Working software</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">AI modules</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">SaaS product</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Infrastructure component</span>
                  </div>
                </div>
              </div>
            </div>}
            { stage === "validate" && 
            <div className="mt-6 bg-surface-1 dark:bg-surface-2 text-on-surface-1 border border-surface-3 rounded-xl p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#E8751A]/10 flex items-center justify-center flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                    stroke-linejoin="round" className="text-primary">
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="m9 12 2 2 4-4"></path>
                  </svg>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="font-mono text-[10px] text-primary uppercase tracking-widest">Stage 04</span>
                    <span className="font-display dark:text-on-primary text-lg font-bold">Validate</span>
                    <span className="text-sm">— Validate Fit & Security</span>
                  </div>
                  <p className="text-sm leading-relaxed mb-4 max-w-3xl">
                    Rigorous testing of functional correctness, AI model accuracy, security posture, and compliance requirements — validating both technical performance and business fit.
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Test results</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Performance report</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Security review</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Acceptance sign-off</span>
                  </div>
                </div>
              </div>
            </div>}
            { stage === "deploy" && 
            <div className="mt-6 bg-surface-1 dark:bg-surface-2 text-on-surface-1 border border-surface-3 rounded-xl p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#E8751A]/10 flex items-center justify-center flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                    stroke-linejoin="round" className="text-primary">
                      <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"></path>
                      <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"></path>
                      <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"></path>
                      <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"></path>
                  </svg>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="font-mono text-[10px] text-primary uppercase tracking-widest">Stage 05</span>
                    <span className="font-display dark:text-on-primary text-lg font-bold">Deploy</span>
                    <span className="text-sm">— Deploy with Training</span>
                  </div>
                  <p className="text-sm leading-relaxed mb-4 max-w-3xl">
                    Structured deployment with comprehensive user training, change management support, and go-live monitoring to ensure adoption is as robust as the technology.
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Production deployment</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">User training</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Monitoring setup</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Go-live support</span>
                  </div>
                </div>
              </div>
            </div>}
            { stage === "optimize" && 
            <div className="mt-6 bg-surface-1 dark:bg-surface-2 text-on-surface-1 border border-surface-3 rounded-xl p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#E8751A]/10 flex items-center justify-center flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                    stroke-linejoin="round" className="text-primary">
                      <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
                      <polyline points="16 7 22 7 22 13"></polyline>
                  </svg>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="font-mono text-[10px] text-primary uppercase tracking-widest">Stage 06</span>
                    <span className="font-display dark:text-on-primary text-lg font-bold">Optimize</span>
                    <span className="text-sm">— Optimize Value</span>
                  </div>
                  <p className="text-sm leading-relaxed mb-4 max-w-3xl">
                    Post-deployment, measure outcomes against KPIs, refine AI models with new data, and continuously improve performance. Long-term value creation is the measure of success.
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">KPI measurement</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">AI model refinement</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Performance tuning</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Enhancement roadmap</span>
                  </div>
                </div>
              </div>
            </div>}
          </div>
          <div className="lg:hidden space-y-4">
            <div className="mt-6 bg-surface-1 dark:bg-surface-2 text-on-surface-1 border border-surface-3 rounded-xl p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#E8751A]/10 flex items-center justify-center flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                    stroke-linejoin="round" className="text-primary">
                      <circle cx="11" cy="11" r="8"></circle>
                      <path d="m21 21-4.3-4.3"></path>
                  </svg>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="font-mono text-[10px] text-primary uppercase tracking-widest">Stage 01</span>
                    <span className="font-display dark:text-on-primary text-lg font-bold">Discover</span>
                  </div>
                  <p className="text-sm leading-relaxed mb-4 max-w-3xl">
                    Deep-dive into your business context, pain points, existing systems, and strategic goals. Define the problem before proposing any solution.
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Discovery report</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Problem definition</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Opportunity map</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Requirement baseline</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-6 bg-surface-1 dark:bg-surface-2 text-on-surface-1 border border-surface-3 rounded-xl p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#E8751A]/10 flex items-center justify-center flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                    stroke-linejoin="round" className="text-primary">
                      <path d="m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z"></path>
                      <circle cx="12" cy="12" r="10"></circle>
                  </svg>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="font-mono text-[10px] text-primary uppercase tracking-widest">Stage 02</span>
                    <span className="font-display dark:text-on-primary text-lg font-bold">Design</span>
                  </div>
                  <p className="text-sm leading-relaxed mb-4 max-w-3xl">
                    Architect the solution — defining the technical blueprint, data flows, AI model strategy, integration points, and user experience.
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Solution blueprint</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Architecture design</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Roadmap</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Implementation plan</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-6 bg-surface-1 dark:bg-surface-2 text-on-surface-1 border border-surface-3 rounded-xl p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#E8751A]/10 flex items-center justify-center flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                    stroke-linejoin="round" className="text-primary">
                      <path d="m18 16 4-4-4-4"></path>
                      <path d="m6 8-4 4 4 4"></path>
                      <path d="m14.5 4-5 16"></path>
                  </svg>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="font-mono text-[10px] text-primary uppercase tracking-widest">Stage 03</span>
                    <span className="font-display dark:text-on-primary text-lg font-bold">Develop</span>
                  </div>
                  <p className="text-sm leading-relaxed mb-4 max-w-3xl">
                    Agile, AI-first development with continuous integration and modular architecture. Build iteratively with regular demos and progress checkpoints.
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Working software</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">AI modules</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">SaaS product</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Infrastructure component</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-6 bg-surface-1 dark:bg-surface-2 text-on-surface-1 border border-surface-3 rounded-xl p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#E8751A]/10 flex items-center justify-center flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                    stroke-linejoin="round" className="text-primary">
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="m9 12 2 2 4-4"></path>
                  </svg>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="font-mono text-[10px] text-primary uppercase tracking-widest">Stage 04</span>
                    <span className="font-display dark:text-on-primary text-lg font-bold">Validate</span>
                  </div>
                  <p className="text-sm leading-relaxed mb-4 max-w-3xl">
                    Rigorous testing of functional correctness, AI model accuracy, security posture, and compliance requirements — validating both technical performance and business fit.
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Test results</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Performance report</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Security review</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Acceptance sign-off</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-6 bg-surface-1 dark:bg-surface-2 text-on-surface-1 border border-surface-3 rounded-xl p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#E8751A]/10 flex items-center justify-center flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                    stroke-linejoin="round" className="text-primary">
                      <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"></path>
                      <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"></path>
                      <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"></path>
                      <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"></path>
                  </svg>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="font-mono text-[10px] text-primary uppercase tracking-widest">Stage 05</span>
                    <span className="font-display dark:text-on-primary text-lg font-bold">Deploy</span>
                  </div>
                  <p className="text-sm leading-relaxed mb-4 max-w-3xl">
                    Structured deployment with comprehensive user training, change management support, and go-live monitoring to ensure adoption is as robust as the technology.
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Production deployment</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">User training</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Monitoring setup</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Go-live support</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-6 bg-surface-1 dark:bg-surface-2 text-on-surface-1 border border-surface-3 rounded-xl p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#E8751A]/10 flex items-center justify-center flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                    stroke-linejoin="round" className="text-primary">
                      <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
                      <polyline points="16 7 22 7 22 13"></polyline>
                  </svg>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="font-mono text-[10px] text-primary uppercase tracking-widest">Stage 06</span>
                    <span className="font-display dark:text-on-primary text-lg font-bold">Optimize</span>
                  </div>
                  <p className="text-sm leading-relaxed mb-4 max-w-3xl">
                    Post-deployment, measure outcomes against KPIs, refine AI models with new data, and continuously improve performance. Long-term value creation is the measure of success.
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">KPI measurement</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">AI model refinement</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Performance tuning</span>
                    <span className="px-3 py-1 bg-surface-4 border border-surface-3 rounded text-xs font-mono">Enhancement roadmap</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mt-20">
            <div className="border-l border-primary pl-5">
              <h4 className="font-space font-semibold text-on-surface-1 dark:text-on-primary mb-4">
                Transparency
              </h4>
              <p className="text-sm">
                Clients have full visibility into progress, decisions, and deliverables at every stage.
              </p>
            </div>
            <div className="border-l border-primary pl-5">
              <h4 className="font-space font-semibold text-on-surface-1 dark:text-on-primary mb-4">
                Quality Control
              </h4>
              <p className="text-sm">
                Structured validation gates ensure business fit, security, and performance before deployment.
              </p>
            </div>
            <div className="border-l border-primary pl-5">
              <h4 className="font-space font-semibold text-on-surface-1 dark:text-on-primary mb-4">
                Measurable Impact
              </h4>
              <p className="text-sm">
                Every engagement is tied to defined business outcomes, not just technical outputs.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-surface-1 text-on-surface-1 px-6 md:px-12 lg:px-20 py-20" id="leadership">
        <div className="max-w-[95rem] mx-auto">
          <div className="max-w-4xl">
            <p className="text-primary uppercase tracking-[0.3em] text-xs font-mono font-semibold mb-6">
              [06] — Leadership Team
            </p>
            <h2 className="hidden lg:block text-5xl font-space font-bold leading-tight dark:text-on-primary">
              Built for the&nbsp;
              <span className="text-primary">Next Era</span>
              <br />
              of Enterprise Technology
            </h2>
            <h2 className="text-4xl lg:hidden font-space font-bold leading-tight dark:text-on-primary">
              Built for the
            </h2>
            <h2 className="text-4xl lg:hidden font-space font-bold leading-tight text-primary">
              Next Era
            </h2>
            <h2 className="text-4xl lg:hidden font-space font-bold leading-tight dark:text-on-primary">
              of Enterprise Technology
            </h2>
            <p className="mt-8 leading-relaxed max-w-3xl">
              DIGIWORKS LIMITED is led by a founding team with a combined 50+ years of experience across enterprise technology, AI engineering, infrastructure, and business development.
            </p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-20">
            <div className="bg-surface-2 border border-surface-3 rounded-2xl overflow-hidden">
              <div className="h-1 w-full bg-primary"></div>
              <div className="p-8">
                <div className="flex items-start gap-5">
                  <div className="w-14 h-14 rounded-xl border border-primary bg-[#452f1e] flex items-center justify-center shrink-0">
                    <span className="text-primary font-mono font-bold">WZ</span>
                  </div>
                  <div>
                    <h3 className="font-space text-lg font-bold dark:text-on-primary">
                      Wahid Uz Zaman
                    </h3>
                    <p className="text-primary text-xs font-mono uppercase mt-2">
                      Founder &amp; CEO
                    </p>
                  </div>
                </div>
                {profileExpandIndex !== "01" && 
                <div>
                  <p className="mt-10 leading-relaxed text-sm">
                    Founder and CEO of DIGIWORKS LIMITED, bringing over 25 years of leadership experience in IT infrastructure, enterprise networking, 
                    information security, and business development. Leads DIGIWORKS' vision for AI-centric software, Agentic AI, IoT, cloud, and 
                    global technology solutions.
                  </p>
                  <div className="border-t border-surface-3 mt-10 pt-6">
                    <button onClick={() => setProfileExpandIndex("01")} className="text-sm text-primary font-semibold hover:opacity-80 transition">
                      Read Full Profile →
                    </button>
                  </div>
                </div>}
                {profileExpandIndex === "01" && 
                <div>
                  <p className="mt-10 leading-relaxed text-sm">
                    Wahid Uz Zaman is a visionary entrepreneur and technology leader with over 25 years of experience in IT infrastructure, 
                    enterprise networking, information security, and IT training. As the Founder and CEO of DIGIWORKS Limited, he leads the company's 
                    strategic direction, global expansion, and innovation roadmap across AI-centric software development, Agentic AI workflows, IoT, 
                    cloud, and sensor-based solutions. A respected industry professional and the second CCIE-certified expert in Bangladesh, 
                    Wahid combines deep technical expertise with strong business leadership, strategic planning, people management, and market 
                    development capabilities.
                  </p>
                  <div class="font-mono text-[10px] uppercase tracking-widest mt-3 mb-3">Key Highlights</div>
                  <ul class="space-y-2">
                    <li class="flex items-start gap-2 text-xs">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" 
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mt-0.5 flex-shrink-0" style={{color: 'rgb(232, 117, 26)'}}>
                        <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                        <circle cx="12" cy="8" r="6"></circle>
                      </svg>
                      25+ years in IT infrastructure &amp; enterprise networking
                    </li>
                    <li class="flex items-start gap-2 text-xs">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" 
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mt-0.5 flex-shrink-0" style={{color: 'rgb(232, 117, 26)'}}>
                        <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                        <circle cx="12" cy="8" r="6"></circle>
                      </svg>
                      2nd CCIE-certified expert in Bangladesh
                    </li>
                    <li class="flex items-start gap-2 text-xs">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" 
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mt-0.5 flex-shrink-0" style={{color: 'rgb(232, 117, 26)'}}>
                        <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                        <circle cx="12" cy="8" r="6"></circle>
                      </svg>
                      Leads strategic direction &amp; global expansion
                    </li>
                    <li class="flex items-start gap-2 text-xs">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" 
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mt-0.5 flex-shrink-0" style={{color: 'rgb(232, 117, 26)'}}>
                        <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                        <circle cx="12" cy="8" r="6"></circle>
                      </svg>
                      Expert in AI, IoT, cloud &amp; sensor-based solutions
                    </li>
                  </ul>
                  <div className="border-t border-surface-3 mt-10 pt-6">
                    <button onClick={() => setProfileExpandIndex("00")} className="text-sm text-primary font-semibold hover:opacity-80 transition">
                      Show Less
                    </button>
                  </div>
                </div>}
              </div>
            </div>
            <div className="bg-surface-2 border border-blue-400/20 rounded-2xl overflow-hidden">
              <div className="h-1 w-full bg-blue-400"></div>
              <div className="p-8">
                <div className="flex items-start gap-5">
                  <div className="w-14 h-14 rounded-xl border border-blue-400/30 bg-blue-400/10 flex items-center justify-center shrink-0">
                    <span className="text-blue-400 font-mono font-bold">PKD</span>
                  </div>
                  <div>
                    <h3 className="font-space text-lg font-bold dark:text-on-primary">
                      Pradip Kumar Dey
                    </h3>
                    <p className="text-blue-400 text-xs font-mono uppercase mt-2">
                      Co-Founder &amp; CTO
                    </p>
                  </div>
                </div>
                {profileExpandIndex !== "02" && 
                <div>
                  <p className="mt-10 leading-relaxed text-sm">
                    Co-Founder and CTO of DIGIWORKS LIMITED, with over 25 years of experience in AI, Industrial IoT, telecom, data center, and enterprise 
                    technology architecture. Leads the company's technical strategy, solution architecture, and engineering innovation.
                  </p>
                  <div className="border-t border-surface-3 mt-10 pt-6">
                    <button onClick={() => setProfileExpandIndex("02")} className="text-sm text-blue-400 font-semibold hover:opacity-80 transition">
                      Read Full Profile →
                    </button>
                  </div>
                </div>}
                {profileExpandIndex === "02" && 
                <div>
                  <p className="mt-10 leading-relaxed text-sm">
                    Pradip Kumar Dey is a seasoned technology leader with more than 25 years of experience in AI, Industrial IoT, software platforms, 
                    and high-scale network infrastructure. As Co-Founder and CTO of DIGIWORKS Limited, he drives the company's technology architecture, 
                    product engineering, and innovation initiatives, including AI-integrated age-care solutions, secure IoT frameworks, enterprise 
                    automation platforms, and specialized technical service teams. With extensive leadership experience across telecom, data center, 
                    cloud, and enterprise systems, Pradip brings a strong track record of building scalable infrastructure, leading high-performance 
                    engineering teams, and transforming complex systems through automation and intelligent technologies.
                  </p>
                  <div class="font-mono text-[10px] uppercase tracking-widest mt-3 mb-3">Key Highlights</div>
                  <ul class="space-y-2">
                    <li class="flex items-start gap-2 text-xs">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" 
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mt-0.5 flex-shrink-0" style={{color: 'rgb(123, 159, 255)'}}>
                        <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                        <circle cx="12" cy="8" r="6"></circle>
                      </svg>
                      25+ years in AI, Industrial IoT &amp; telecom
                    </li>
                    <li class="flex items-start gap-2 text-xs">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" 
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mt-0.5 flex-shrink-0" style={{color: 'rgb(123, 159, 255)'}}>
                        <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                        <circle cx="12" cy="8" r="6"></circle>
                      </svg>
                      Leads technology architecture &amp; product engineering
                    </li>
                    <li class="flex items-start gap-2 text-xs">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" 
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mt-0.5 flex-shrink-0" style={{color: 'rgb(123, 159, 255)'}}>
                        <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                        <circle cx="12" cy="8" r="6"></circle>
                      </svg>
                      Expert in data center, cloud &amp; enterprise systems
                    </li>
                    <li class="flex items-start gap-2 text-xs">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" 
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mt-0.5 flex-shrink-0" style={{color: 'rgb(123, 159, 255)'}}>
                        <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                        <circle cx="12" cy="8" r="6"></circle>
                      </svg>
                      AI-integrated age-care &amp; IoT framework specialist
                    </li>
                  </ul>
                  <div className="border-t border-surface-3 mt-10 pt-6">
                    <button onClick={() => setProfileExpandIndex("00")} className="text-sm text-blue-400 font-semibold hover:opacity-80 transition">
                      Show Less
                    </button>
                  </div>
                </div>}
              </div>
            </div>
            {/* <div className="bg-surface-2 border border-yellow-400/20 rounded-2xl overflow-hidden">
              <div className="h-1 w-full bg-yellow-400"></div>
              <div className="p-8">
                <div className="flex items-start gap-5">
                  <div className="w-14 h-14 rounded-xl border border-yellow-400/30 bg-yellow-400/10 flex items-center justify-center shrink-0">
                    <span className="text-yellow-400 font-mono font-bold">SH</span>
                  </div>
                  <div>
                    <h3 className="font-space text-lg font-bold dark:text-on-primary">
                      Sakhawat Hossen
                    </h3>
                    <p className="text-yellow-400 text-xs font-mono uppercase mt-2">
                      Co-Founder &amp; AI Solution Architect
                    </p>
                  </div>
                </div>
                {profileExpandIndex !== "03" && 
                <div>
                  <p className="mt-10 leading-relaxed text-sm">
                    Co-Founder and AI Solution Architect of DIGIWORKS LIMITED, specializing in AI/ML, full-stack development, computer vision, distributed 
                    systems, and Agentic AI. Designs scalable AI-powered platforms and production-ready intelligent solutions.
                  </p>
                  <div className="border-t border-surface-3 mt-10 pt-6">
                    <button onClick={() => setProfileExpandIndex("03")} className="text-sm text-yellow-400 font-semibold hover:opacity-80 transition">
                      Read Full Profile →
                    </button>
                  </div>
                </div>}
                {profileExpandIndex === "03" && 
                <div>
                  <p className="mt-10 leading-relaxed text-sm">
                    Sakhawat Hossen is an AI/ML engineer, full-stack developer, and distributed systems architect with over 7 years of experience building 
                    scalable, production-ready software solutions. As Co-Founder and AI Solution Architect at DIGIWORKS Limited, he leads the design and 
                    development of AI-powered applications, real-time data platforms, computer vision systems, and automation solutions. His expertise 
                    spans Agentic AI, RAG systems, computer vision, microservices, event-driven architecture, DevOps, and cloud-native development. 
                    Sakhawat has delivered impactful solutions in age-care safety monitoring, document intelligence, bid automation, asset tracking, 
                    logistics, ERP, and high-traffic e-commerce platforms.
                  </p>
                  <div class="font-mono text-[10px] uppercase tracking-widest mt-3 mb-3">Key Highlights</div>
                  <ul class="space-y-2">
                    <li class="flex items-start gap-2 text-xs">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" 
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mt-0.5 flex-shrink-0" style={{color: 'rgb(245, 166, 35)'}}>
                        <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                        <circle cx="12" cy="8" r="6"></circle>
                      </svg>
                      7+ years in AI/ML &amp; full-stack development
                    </li>
                    <li class="flex items-start gap-2 text-xs">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" 
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mt-0.5 flex-shrink-0" style={{color: 'rgb(245, 166, 35)'}}>
                        <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                        <circle cx="12" cy="8" r="6"></circle>
                      </svg>
                      Expert in Agentic AI, RAG &amp; computer vision
                    </li>
                    <li class="flex items-start gap-2 text-xs">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" 
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mt-0.5 flex-shrink-0" style={{color: 'rgb(245, 166, 35)'}}>
                        <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                        <circle cx="12" cy="8" r="6"></circle>
                      </svg>
                      Microservices, event-driven &amp; cloud-native architectur
                    </li>
                    <li class="flex items-start gap-2 text-xs">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" 
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mt-0.5 flex-shrink-0" style={{color: 'rgb(245, 166, 35)'}}>
                        <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                        <circle cx="12" cy="8" r="6"></circle>
                      </svg>
                      Delivered solutions across healthcare, logistics &amp; e-commerce
                    </li>
                  </ul>
                  <div className="border-t border-surface-3 mt-10 pt-6">
                    <button onClick={() => setProfileExpandIndex("00")} className="text-sm text-yellow-400 font-semibold hover:opacity-80 transition">
                      Show Less
                    </button>
                  </div>
                </div>}
              </div>
            </div> */}
          </div>
        </div>
      </section>

      <section className="bg-surface-4 text-on-surface-1 px-6 md:px-12 lg:px-20 py-20" id="contact">
        <div className="max-w-[95rem] mx-auto">
          <div className="max-w-4xl">
            <p className="text-primary uppercase tracking-[0.3em] text-xs font-mono font-semibold mb-6">
              [07] — Get In Touch
            </p>
            <h2 className="text-4xl lg:text-5xl font-space font-bold leading-tight dark:text-on-primary">
              Let’s Build&nbsp;
              <span className="text-primary">Intelligent Digital</span>
              <br />
              Solutions Together.
            </h2>
            <p className="mt-8 leading-relaxed max-w-3xl">
              Whether you are exploring AI adoption, planning a digital transformation, or looking to build a scalable SaaS product — we would like to hear about your challenges and goals.
            </p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mt-20">
            <div className="space-y-8">
              <div className="bg-surface-2 border border-surface-3 rounded-2xl p-8">
                <p className="text-xs font-mono uppercase tracking-[0.2em] mb-8">
                  Contact Information
                </p>
                <div className="space-y-8">
                  <div className="flex gap-5">
                    <div className="w-12 h-12 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center shrink-0">
                      <span className="text-primary">◉</span>
                    </div>
                    <div>
                      <p className="font-mono text-xs uppercase mb-2">
                        Address
                      </p>
                      <p className="text-sm font-semibold leading-relaxed dark:text-on-primary">
                        2/0 Uttar Adabor, Ring Road
                        <br />
                        Dhaka-1207, Bangladesh
                      </p>
                    </div>
                  </div>
                  <div className="flex gap-5">
                    <div className="w-12 h-12 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center shrink-0">
                      <span className="text-primary">◉</span>
                    </div>
                    <div>
                      <p className="font-mono text-xs uppercase mb-2">
                        Phone
                      </p>
                      <p className="text-sm font-semibold leading-relaxed dark:text-on-primary">
                        09678 800 444
                      </p>
                    </div>
                  </div>
                  <div className="flex gap-5">
                    <div className="w-12 h-12 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center shrink-0">
                      <span className="text-primary">◉</span>
                    </div>
                    <div>
                      <p className="font-mono text-xs uppercase mb-2">
                        Email
                      </p>
                      <p className="text-sm font-semibold leading-relaxed dark:text-on-primary">
                        info@dgworks.ai
                      </p>
                    </div>
                  </div>
                  <div className="flex gap-5">
                    <div className="w-12 h-12 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center shrink-0">
                      <span className="text-primary">◉</span>
                    </div>
                    <div>
                      <p className="font-mono text-xs uppercase mb-2">
                        Website
                      </p>
                      <p className="text-sm font-semibold leading-relaxed dark:text-on-primary">
                        www.dgworks.ai
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-surface-2 border border-surface-3 rounded-2xl p-8">
                <p className="text-xs font-mono uppercase tracking-[0.2em] mb-8">
                  What To Expect
                </p>
                <div className="text-sm space-y-5">
                  <div className="flex items-start gap-4">
                    <span className="text-primary mt-1">→</span>
                    <p className="leading-relaxed">
                      Initial consultation to understand your business challenges
                    </p>
                  </div>
                  <div className="flex items-start gap-4">
                    <span className="text-primary mt-1">→</span>
                    <p className="leading-relaxed">
                      Honest assessment of where AI and digital solutions can create value
                    </p>
                  </div>
                  <div className="flex items-start gap-4">
                    <span className="text-primary mt-1">→</span>
                    <p className="leading-relaxed">
                      A structured proposal aligned to your goals and budget
                    </p>
                  </div>
                  <div className="flex items-start gap-4">
                    <span className="text-primary mt-1">→</span>
                    <p className="leading-relaxed">
                      A long-term partnership focused on measurable business outcomes
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-surface-2 border border-surface-3 text-on-surface-1 rounded-2xl p-8">
              <form className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  <div>
                    <label className="block font-mono text-xs uppercase tracking-[0.2em] mb-3">
                      Full Name *
                    </label>
                    <input
                      type="text"
                      placeholder="Your full name"
                      className="w-full bg-surface-4 border border-surface-3 rounded-lg px-5 py-4 outline-none focus:border-primary transition"
                    />
                  </div>
                  <div>
                    <label className="block font-mono text-xs uppercase tracking-[0.2em] mb-3">
                      Email Address *
                    </label>
                    <input
                      type="email"
                      placeholder="your@email.com"
                      className="w-full bg-surface-4 border border-surface-3 rounded-lg px-5 py-4 outline-none focus:border-primary transition"
                    />
                  </div>
                </div>
                <div>
                  <label className="block font-mono text-xs uppercase tracking-[0.2em] mb-3">
                    Company / Organization
                  </label>
                  <input
                    type="text"
                    placeholder="Your organization name"
                    className="w-full bg-surface-4 border border-surface-3 rounded-lg px-5 py-4 outline-none focus:border-primary transition"
                  />
                </div>
                <div>
                  <label className="block font-mono text-xs uppercase tracking-[0.2em] mb-3">
                    Service Of Interest
                  </label>
                  <select
                    className="w-full bg-surface-4 border border-surface-3 rounded-lg px-5 py-4 outline-none focus:border-primary transition"
                  >
                    <option value="">Select a service...</option>
                    <option value="ai-software">AI-Centric Software Development</option>
                    <option value="saas">SaaS Innovation &amp; Product Development</option>
                    <option value="advisory">Enterprise Digitization &amp; AI Advisory</option>
                    <option value="infrastructure">Infrastructure Design &amp; Implementation</option>
                    <option value="capability">AI Engineering Capability Development</option>
                    <option value="consulting">Strategic Consulting &amp; Market Development</option>
                    <option value="product">Product / Platform Enquiry</option>
                  </select>
                </div>
                <div>
                  <label className="block font-mono text-xs uppercase tracking-[0.2em] mb-3">
                    How Can We Help? *
                  </label>
                  <textarea
                    rows="6"
                    placeholder="Describe your business challenge, project idea, or question..."
                    className="w-full bg-surface-4 border border-surface-3 rounded-lg px-5 py-4 outline-none focus:border-primary transition resize-none"
                  ></textarea>
                </div>
                <div>
                  <button
                    type="button"
                    className="w-full bg-primary hover:opacity-90 transition text-on-primary font-semibold py-4 rounded-lg shadow-lg shadow-primary/20"
                  >
                    Send Message →
                  </button>
                  <p className="text-center text-sm text-on-secondary/40 mt-5">
                    We typically respond within 1-2 business days.
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      
      <footer className="bg-[#bdbdbd] dark:bg-[#080C18] text-on-surface-1 pl-8 lg:pl-0 py-12 border-t border-[#9b9b9b] dark:border-[#494949]">
        <div className="max-w-[95rem] mx-auto">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <div className="lg:col-span-2">
              <img alt="DigiWorks" className="h-10 w-[130px] object-contain mb-4 dark:hidden" src={Logo} />
              <img alt="DigiWorks" className="h-10 w-[130px] object-contain mb-4 hidden dark:block" src={Logo2} />
              <p className="text-sm leading-relaxed max-w-xs">
                An AI-centric technology company from Bangladesh, empowering enterprises locally and globally through intelligent software, scalable SaaS platforms, 
                trusted digital infrastructure, and world-class AI talent.
              </p>
              <div className="mt-4 space-y-1">
                <p className="text-xs">2/G Uttar Adabor, Ring Road, Dhaka-1207</p>
                <p className="text-xs">09678 800 444 · info@dgworks.ai</p>
                <a href="https://www.dgworks.ai" className="text-primary text-xs hover:underline">www.dgworks.ai</a>
              </div>
            </div>
            <div>
              <div className="font-mono text-[10px] uppercase tracking-widest mb-4">Services</div>
              <ul className="space-y-2">
                <li className="text-xs hover:text-primary transition-colors cursor-default">AI-Centric Software Development</li>
                <li className="text-xs hover:text-primary transition-colors cursor-default">SaaS Innovation &amp; Product Development</li>
                <li className="text-xs hover:text-primary transition-colors cursor-default">Enterprise Digitization &amp; AI Advisory</li>
                <li className="text-xs hover:text-primary transition-colors cursor-default">Infrastructure Design &amp; Implementation</li>
                <li className="text-xs hover:text-primary transition-colors cursor-default">AI Engineering Capability Development</li>
                <li className="text-xs hover:text-primary transition-colors cursor-default">Strategic Consulting</li>
              </ul>
            </div>
            <div>
              <div className="font-mono text-[10px] uppercase tracking-widest mb-4">Products</div>
              <ul className="space-y-2">
                <li className="text-xs hover:text-primary transition-colors cursor-default">Age-Care by AI</li>
                <li className="text-xs hover:text-primary transition-colors cursor-default">AI News Agency</li>
                <li className="text-xs hover:text-primary transition-colors cursor-default">TVET AI Companion</li>
                <li className="text-xs hover:text-primary transition-colors cursor-default">HR Recruitment by AI</li>
                <li className="text-xs hover:text-primary transition-colors cursor-default">StoryBox (Coming Soon)</li>
                <li className="text-xs hover:text-primary transition-colors cursor-default">TripNexus (Coming Soon)</li>
                <li className="text-xs hover:text-primary transition-colors cursor-default">EventPilot (Coming Soon)</li>
              </ul>
            </div>
          </div>
          <div style={{ background: 'linear-gradient(90deg, rgba(0, 0, 0, 0), rgba(232, 117, 26, 0.3), rgba(0, 0, 0, 0))', height: '1px'}}></div>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-4">
            <p className="text-xs">© 2026 DIGIWORKS LIMITED. All rights reserved. Dhaka, Bangladesh.</p>
            <div className="flex items-center gap-1">
              <span className="font-mono text-xs">AI-CENTRIC</span>
              <span className="w-1 h-1 rounded-full bg-primary mx-2"></span>
              <span className="font-mono text-xs">ENTERPRISE-GRADE</span>
            </div>
          </div>
        </div>
      </footer>

    </main>
  );
}

export default Main;
